import { GraphQLClient } from "graphql-request";
import { GraphQLClientRequestHeaders } from "graphql-request/build/cjs/types";
import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  URI: { input: any; output: any };
  URITemplate: { input: any; output: any };
};

export type Action = {
  __typename?: "Action";
  /** Primary argument for the action. */
  arg?: Maybe<Scalars["String"]["output"]>;
  /** Text for the button (only used for promo redeem at present). */
  buttonText?: Maybe<Scalars["String"]["output"]>;
  /** Pre-requisites to perform the action. Note: the order is important. */
  requirements?: Maybe<Array<ActionRequirements>>;
  /** The action to perform when the user taps the card. */
  type: ActionType;
};

export enum ActionRequirements {
  /** The user must confirm the purchase via a dialog */
  ConfirmBuy = "CONFIRM_BUY",
  /** The user must have Facebook publish permissions */
  FacebookPublish = "FACEBOOK_PUBLISH",
  /** The user must provide the app with location services / GPS permissions */
  Gps = "GPS",
  /** The user must have payments connected (Aston Club) */
  Payments = "PAYMENTS",
  /** The user must have a payment method (eg: valid credit card) */
  PaymentMethod = "PAYMENT_METHOD",
}

export enum ActionType {
  DisplayDetails = "DISPLAY_DETAILS",
  OkDialog = "OK_DIALOG",
  OpenUrl = "OPEN_URL",
  PromptAuth = "PROMPT_AUTH",
  RedeemPromo = "REDEEM_PROMO",
  ResendVerification = "RESEND_VERIFICATION",
}

/** Represents a single activity for a user */
export type Activity = {
  /** Unique ID */
  id: Scalars["String"]["output"];
  /** The name of the location this activity was at */
  locationName?: Maybe<Scalars["String"]["output"]>;
  /** The time this activity or event occurred */
  timestamp: Scalars["Date"]["output"];
  /** Title string */
  title: Scalars["String"]["output"];
};

/** Results for an activity query */
export type ActivityResult = {
  __typename?: "ActivityResult";
  /** The items for the query results */
  items: Array<Activity>;
  /** Pagination information */
  pageInfo: PageInfo;
  summary: ActivitySummary;
};

/** Summary for the MyActivity section */
export type ActivitySummary = {
  __typename?: "ActivitySummary";
  credit: Scalars["Int"]["output"];
  itemCount: Scalars["Int"]["output"];
  points: Scalars["Int"]["output"];
};

export type AddWalletInput = {
  /** DBS is no args - if returnURL is provided the PayLah app will bounce to this */
  returnURL?: InputMaybe<Scalars["String"]["input"]>;
  /** Masterpass only */
  token?: InputMaybe<Scalars["String"]["input"]>;
};

/** Results for an addWallet request */
export type AddWalletResult = MutationResult & {
  __typename?: "AddWalletResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful provides the payment method data */
  paymentMethods?: Maybe<Array<PaymentMethod>>;
};

export type Address = {
  __typename?: "Address";
  country?: Maybe<Scalars["String"]["output"]>;
  locality?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  region?: Maybe<Scalars["String"]["output"]>;
  street?: Maybe<Scalars["String"]["output"]>;
  street2?: Maybe<Scalars["String"]["output"]>;
};

export type AddressAutocomplete = {
  __typename?: "AddressAutocomplete";
  /** Friendly display name that summarises the entire address details. Useful for concise display. */
  name: Scalars["String"]["output"];
  /** Ref for the full address, pass it to address query to resolve to AddressDetails */
  ref: Scalars["String"]["output"];
};

export type AddressDelivery = {
  __typename?: "AddressDelivery";
  apartment?: Maybe<Scalars["String"]["output"]>;
  coords: Coords;
  country: Scalars["String"]["output"];
  locality: Scalars["String"]["output"];
  postcode: Scalars["String"]["output"];
  region: Scalars["String"]["output"];
  streetAddress: Scalars["String"]["output"];
};

export type AddressDetails = {
  __typename?: "AddressDetails";
  /** The geocoordinates of the address (lat, lng) */
  coords: Coords;
  /** The country, eg United Kingdom, Australia */
  country: Scalars["String"]["output"];
  /** The suburb or similar locality (sub-region) */
  locality: Scalars["String"]["output"];
  /** Friendly display name that summarises the entire address details. Useful for concise display. */
  name: Scalars["String"]["output"];
  /** The post code for this address */
  postcode: Scalars["String"]["output"];
  /** The region, province, etc */
  region: Scalars["String"]["output"];
  /** Street address (unit + number + name) */
  streetAddress: Scalars["String"]["output"];
};

/** Represents a failure to query address details */
export type AddressDetailsError = {
  __typename?: "AddressDetailsError";
  /** The message for an error */
  message: Scalars["String"]["output"];
};

export type AddressDetailsResponse = {
  __typename?: "AddressDetailsResponse";
  /** If successful provides the requested details */
  details?: Maybe<AddressDetails>;
  /** If unsuccessful this will be set and indicates why the query failed */
  error?: Maybe<AddressDetailsError>;
};

/** Authorize payment result extends a mutation result, but also provides the nonce for the payment in the event of success */
export type AuthorizePaymentResult = MutationResult & {
  __typename?: "AuthorizePaymentResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful provides the payment method nonce */
  nonce?: Maybe<Scalars["String"]["output"]>;
};

/** DEPRECATED */
export type AuthorizedPayment = {
  __typename?: "AuthorizedPayment";
  nonce: Scalars["String"]["output"];
};

export type Balance = {
  __typename?: "Balance";
  /** Amount of credit available at this location */
  credit?: Maybe<Scalars["Int"]["output"]>;
  /** Retrieves the customer's available credit at this location, formatted into a string. */
  creditText?: Maybe<Scalars["String"]["output"]>;
  /** Returns points balance formatted appropriately to use in the app header. */
  pointsText?: Maybe<Scalars["String"]["output"]>;
};

/** Bill Payments config */
export type BillPaymentConfig = {
  __typename?: "BillPaymentConfig";
  /** text to prompt for ref (bill/register number) */
  refPromptText: Scalars["String"]["output"];
};

export type BillPaymentOption = PaymentOption & {
  __typename?: "BillPaymentOption";
  action: PaymentAction;
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  /** text to prompt for ref (bill/register number) */
  refPromptText: Scalars["String"]["output"];
  scanner: ScannerBehaviour;
  scannerTitle?: Maybe<Scalars["String"]["output"]>;
};

export type BooleanKeyValue = KeyValue & {
  __typename?: "BooleanKeyValue";
  boolValue?: Maybe<Scalars["Boolean"]["output"]>;
  dataType: ValueType;
  key: Scalars["String"]["output"];
  value?: Maybe<Scalars["String"]["output"]>;
};

/** Braintree specific metadata about a gateway. */
export type BraintreeVzeroMetadata = PaymentsMetadata & {
  __typename?: "BraintreeVzeroMetadata";
  /** The public/client token for adding/tokenising new payment methods. */
  clientToken: Scalars["String"]["output"];
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** True if using the Sandbox API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always Braintree type. */
  type: PaymentsType;
};

export type Card = {
  action?: Maybe<Action>;
  badgeText?: Maybe<Scalars["String"]["output"]>;
  details?: Maybe<Scalars["String"]["output"]>;
  displayType?: Maybe<CardDisplayType>;
  id: Scalars["String"]["output"];
  /** Width and height will be applied if possible via image resizer. */
  imageUrl?: Maybe<Scalars["URI"]["output"]>;
  /**
   * Will return a URL template for an image with the follwing fields.
   * w - width of image
   * h - height of image
   * fit - resizing stratergy to use
   *
   * Note these fields are not guaranteed to be on the template.
   */
  imageUrlTemplate?: Maybe<Scalars["URITemplate"]["output"]>;
  /** Catch all general info text that may be displayed in certain situations */
  infoText?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type CardImageUrlArgs = {
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum CardDisplayType {
  /** Order with delivery card */
  Delivery = "DELIVERY",
  /** Full sized card with image */
  Image = "IMAGE",
  /** Order ahead card */
  Order = "ORDER",
  /** Thin Facebook card (check-in) */
  Social = "SOCIAL",
  /** Verification required card */
  Verification = "VERIFICATION",
}

/** Metadata specific to a CARDSTREAM gateway. */
export type CardstreamMetadata = PaymentsMetadata & {
  __typename?: "CardstreamMetadata";
  /**
   * Open this URL in webview (GET) to be redirected to the add card page.
   * (optionally send returnUrl as a query param to override where to be redirected to on completion).
   */
  addCardPageGetUrl: Scalars["String"]["output"];
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** Always CARDSTREAM type. */
  type: PaymentsType;
};

export type Cart = {
  __typename?: "Cart";
  fulfillmentType?: Maybe<FulfillmentType>;
  items: Array<CartItem>;
  locationId: Scalars["String"]["output"];
  locationRef: Scalars["String"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["Date"]["output"];
};

export type CartItem = {
  __typename?: "CartItem";
  id: Scalars["String"]["output"];
  note?: Maybe<Scalars["String"]["output"]>;
  options: Array<CartItemOption>;
  quantity: Scalars["Int"]["output"];
};

export type CartItemChoice = {
  __typename?: "CartItemChoice";
  id: Scalars["String"]["output"];
  options: Array<CartItemOption>;
  quantity: Scalars["Int"]["output"];
};

export type CartItemOption = {
  __typename?: "CartItemOption";
  choices: Array<CartItemChoice>;
  id: Scalars["String"]["output"];
};

export type CheckIn = {
  __typename?: "CheckIn";
  canUpdatePaymentMethod: Scalars["Boolean"]["output"];
  chargeTotal?: Maybe<Scalars["String"]["output"]>;
  expires: Scalars["Date"]["output"];
  finish?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  /** Defined if the check in has a limit (typically a bar tab). */
  limit?: Maybe<Scalars["String"]["output"]>;
  /** Defined if the check in has a limit (typically a bar tab). */
  limitRemaining?: Maybe<Scalars["String"]["output"]>;
  /** The name of the location matching the requested ID (convenience field). */
  locationName: Scalars["String"]["output"];
  number: Scalars["String"]["output"];
  paymentMethod?: Maybe<PaymentMethod>;
  qrCode?: Maybe<QrCode>;
  start: Scalars["Date"]["output"];
  transactions?: Maybe<Array<Transaction>>;
};

export type CheckInPaymentOption = PaymentOption & {
  __typename?: "CheckInPaymentOption";
  action: PaymentAction;
  hasLimit: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
};

/** Check in result extends a mutation result, but also provides the check in in the event of success */
export type CheckInResult = MutationResult & {
  __typename?: "CheckInResult";
  /** If successful provides the check in data */
  checkIn?: Maybe<CheckIn>;
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
};

export type CheckOutResult = MutationResult & {
  __typename?: "CheckOutResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** Message can be displayed to user on completion of check-out */
  message?: Maybe<Scalars["String"]["output"]>;
  /** If successful indicates the amount of points earned during the check in */
  pointsEarned?: Maybe<Scalars["Int"]["output"]>;
  /** Mobile app should display this formatted one instead of using pointsEarned (int) */
  pointsEarnedFormatted?: Maybe<Scalars["String"]["output"]>;
};

/** DEPRECATED */
export type CheckOutResultV1 = {
  __typename?: "CheckOutResultV1";
  pointsEarned?: Maybe<Scalars["Int"]["output"]>;
};

export type Coords = {
  __typename?: "Coords";
  lat: Scalars["Float"]["output"];
  lng: Scalars["Float"]["output"];
};

export type CoordsInput = {
  lat: Scalars["Float"]["input"];
  lng: Scalars["Float"]["input"];
};

/** Contains an OrderSession just like CreateOrderResult */
export type CreateBillPaymentResult = MutationResult & {
  __typename?: "CreateBillPaymentResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful this will provide the details of the order session */
  session?: Maybe<OrderSession>;
};

/** Authorize payment result extends a mutation result, but also provides the nonce for the payment in the event of success */
export type CreateOrderResult = MutationResult & {
  __typename?: "CreateOrderResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** @deprecated Moved into OrderSession */
  requirePhoneVerification?: Maybe<Scalars["Boolean"]["output"]>;
  /** If successful this will provide the details of the order session */
  session?: Maybe<OrderSession>;
};

export type Credit = {
  __typename?: "Credit";
  amount: Scalars["Int"]["output"];
  created: Scalars["Date"]["output"];
  expires: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  remaining: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
};

export type CreditExpiredActivity = Activity & {
  __typename?: "CreditExpiredActivity";
  credit: Credit;
  id: Scalars["String"]["output"];
  locationName?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
};

export type Customer = {
  __typename?: "Customer";
  /** URL to a profile photo for the user. */
  avatar?: Maybe<Scalars["String"]["output"]>;
  /** A list of payment methods (eg: credit cards) available (will be empty list if user has not created a wallet). */
  canEditProfile: Scalars["Boolean"]["output"];
  /**
   * The date the user was created.
   * @deprecated No business logic regarding this
   */
  created: Scalars["Date"]["output"];
  /** Retrieves the customer's available credit at this location, formatted into a string. */
  creditsFormatted?: Maybe<Scalars["String"]["output"]>;
  /** The user's dob as a string (eg: 1980-01-01). */
  dob?: Maybe<Scalars["String"]["output"]>;
  /** The user's email address (and username). Note: this CAN be null for users that sign up with Facebook. */
  emailAddress?: Maybe<Scalars["String"]["output"]>;
  /** The user's first name. */
  firstName: Scalars["String"]["output"];
  /**
   * The user's gender (should probably be enum - MALE, FEMALE).
   * @deprecated No business logic regarding this
   */
  gender?: Maybe<Scalars["String"]["output"]>;
  /** Has the user accepted T&Cs in their profile */
  hasAgreedToTerms: Scalars["Boolean"]["output"];
  /** Returns true if the customer has at least 1 payment method available on their wallet (if they have a wallet). */
  hasPaymentMethod: Scalars["Boolean"]["output"];
  /** Returns true if the customer has payments (Aston Club wallet) connected. */
  hasPayments: Scalars["Boolean"]["output"];
  /** The user's unique ID. */
  id: Scalars["String"]["output"];
  /** Inventory */
  inventory: Array<InventoryItem>;
  /** Returns true if the customer has verified their payments (wallet), ie: mobile number verification. Returns false if payments not set up. */
  isPaymentsVerified: Scalars["Boolean"]["output"];
  /** The user's last name. */
  lastName: Scalars["String"]["output"];
  /** Returns true if the customer is allowed to edit their profile. */
  paymentMethods: Array<PaymentMethod>;
  /** The user's mobile phone number. */
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  /** Returns the customer's available loyalty points. */
  points: Scalars["Int"]["output"];
  /** Returns points balance formatted appropriately to use in the app header. */
  pointsText: Scalars["String"]["output"];
  /** Returns true if the user has completed setting up user profile. */
  profileComplete: Scalars["Boolean"]["output"];
  /** Unique ID to be used for analytics tracking. */
  trackingId: Scalars["String"]["output"];
  /** The timestamp this customer was verified (null if not verified). */
  verified?: Maybe<Scalars["Date"]["output"]>;
};

export type CustomerCreditsFormattedArgs = {
  location: Scalars["String"]["input"];
};

/** Metadata specific to a DBS gateway (Wirecard only). */
export type DbsCardMetadata = PaymentsMetadata & {
  __typename?: "DBSCardMetadata";
  /** Open in webview to be re-directed to the add card page. */
  addCardPagePostUrl: Scalars["String"]["output"];
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** True if using the Sandbox (UAT) API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always DBS_CARD type. */
  type: PaymentsType;
};

/** Metadata specific to a DBS gateway. */
export type DbsMetadata = PaymentsMetadata & {
  __typename?: "DBSMetadata";
  /** Append card details and POST this invisibly (ie: hidden view or like API call). */
  addCardDirectPostUrl: Scalars["String"]["output"];
  /** Open in webview to be re-directed to the add card page. */
  addCardPagePostUrl: Scalars["String"]["output"];
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** True if using the Sandbox (UAT) API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always DBS type. */
  type: PaymentsType;
};

export enum DayOfTheWeek {
  Friday = "FRIDAY",
  Monday = "MONDAY",
  Saturday = "SATURDAY",
  Sunday = "SUNDAY",
  Thursday = "THURSDAY",
  Tuesday = "TUESDAY",
  Wednesday = "WEDNESDAY",
}

export type DefaultCard = Card & {
  __typename?: "DefaultCard";
  action?: Maybe<Action>;
  badgeText?: Maybe<Scalars["String"]["output"]>;
  details?: Maybe<Scalars["String"]["output"]>;
  displayType?: Maybe<CardDisplayType>;
  id: Scalars["String"]["output"];
  /** Width and height will be applied if possible via image resizer. */
  imageUrl?: Maybe<Scalars["URI"]["output"]>;
  /**
   * Will return a URL template for an image with the follwing fields.
   * w - width of image
   * h - height of image
   * fit - resizing stratergy to use
   *
   * Note these fields are not guaranteed to be on the template.
   */
  imageUrlTemplate?: Maybe<Scalars["URITemplate"]["output"]>;
  infoText?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type DefaultCardImageUrlArgs = {
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DeliveryAddress = {
  /** Street address (apartment/unit/suite + number) */
  apartment?: InputMaybe<Scalars["String"]["input"]>;
  /** The geocoordinates of the address (lat, lng) */
  coords?: InputMaybe<CoordsInput>;
  /** The country, eg United Kingdom, Australia */
  country: Scalars["String"]["input"];
  /** The suburb or similar locality (sub-region) */
  locality: Scalars["String"]["input"];
  /** The post code for this address */
  postcode: Scalars["String"]["input"];
  /** The region, province, etc */
  region: Scalars["String"]["input"];
  /** Street address (unit + number + name) */
  streetAddress: Scalars["String"]["input"];
};

export type DeliveryAddressStatus = {
  __typename?: "DeliveryAddressStatus";
  messages: Array<Scalars["String"]["output"]>;
  valid: Scalars["Boolean"]["output"];
};

export type DeliveryCard = Card & {
  __typename?: "DeliveryCard";
  action?: Maybe<Action>;
  badgeText?: Maybe<Scalars["String"]["output"]>;
  /** Final delivery timestamp if available or falls back to max timestamp specified in the settings */
  deliveryAtMax?: Maybe<Scalars["Date"]["output"]>;
  /** Final delivery timestamp if available or falls back to min timestamp specified in the settings */
  deliveryAtMin?: Maybe<Scalars["Date"]["output"]>;
  /** When there is a deliveryTimestamp, display it with this prefix */
  deliveryETAPrefix: Scalars["String"]["output"];
  /** Else display this text, ie: "Delivery in 20-30 mins!" */
  deliveryMessage: Scalars["String"]["output"];
  /**
   * DEPRECATED Delivery state === order state
   * @deprecated Use deliveryStatus
   */
  deliveryState: DeliveryState;
  /** ie: pending, in_transit */
  deliveryStatus?: Maybe<DeliveryStatus>;
  /**
   * Delivery
   * ETA, null, or final delivery timestamp (if available)
   * Needs to be a timestamp so the phone can display user time
   * @deprecated Use deliveryAtMax
   */
  deliveryTimestamp?: Maybe<Scalars["Date"]["output"]>;
  /** Unused */
  details?: Maybe<Scalars["String"]["output"]>;
  /** DELIVERY */
  displayType?: Maybe<CardDisplayType>;
  /** Common */
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["URI"]["output"]>;
  imageUrlTemplate?: Maybe<Scalars["URITemplate"]["output"]>;
  /** Will contain friendly delivery info if available ie: "They are on their way to you" */
  infoText?: Maybe<Scalars["String"]["output"]>;
  /** Location name */
  locationName: Scalars["String"]["output"];
  /**
   * Order
   * Current state of this order.
   */
  state: OrderState;
  /** Time this order was created. */
  timestamp: Scalars["Date"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  /** Total cost of this order formatted. */
  totalFormatted: Scalars["String"]["output"];
};

export type DeliveryCardImageUrlArgs = {
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DeliveryPaymentOption = PaymentOption & {
  __typename?: "DeliveryPaymentOption";
  action: PaymentAction;
  id: Scalars["String"]["output"];
  /** Override "Thankyou for helping our the drivers..." on the first Delivery modal */
  introText?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  /** Override "I'm ordering from" displayed in multiple places */
  locationConfirmText?: Maybe<Scalars["String"]["output"]>;
};

/** Deprecated, same as order state */
export enum DeliveryState {
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
  New = "NEW",
  Success = "SUCCESS",
}

export enum DeliveryStatus {
  DriverAtDropoff = "driver_at_dropoff",
  DriverAtPickup = "driver_at_pickup",
  DriverEnRouteToPickup = "driver_en_route_to_pickup",
  Failed = "failed",
  InTransit = "in_transit",
  LookingForDriver = "looking_for_driver",
  Pending = "pending",
  Success = "success",
}

export type Discount = {
  __typename?: "Discount";
  /** Discount amount based on order total */
  discountAmount: Scalars["Int"]["output"];
  /** The included tax of the discount */
  discountTax?: Maybe<Scalars["Int"]["output"]>;
  /** Unique ID for this discount. */
  id: Scalars["String"]["output"];
  /** ID of the item the discount is being applied to */
  itemId?: Maybe<Scalars["String"]["output"]>;
  /** Name or description of discount */
  name: Scalars["String"]["output"];
  /**
   * Rate, ie: 0.5 is 50% off
   * @deprecated Use discountAmount instead
   */
  rate: Scalars["Float"]["output"];
};

/** FatZebra specific metadata about a gateway */
export type FatZebraCardMasterpassMetadata = PaymentsMetadata & {
  __typename?: "FatZebraCardMasterpassMetadata";
  /** The full URL to direct post. */
  directPostUrl: Scalars["String"]["output"];
  /** URL to web page for managing MasterPass. */
  masterpassManageUrl?: Maybe<Scalars["String"]["output"]>;
  /** URL for pairing MasterPass. */
  masterpassPairingUrl?: Maybe<Scalars["String"]["output"]>;
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** Configured redirection URL. */
  returnPath: Scalars["String"]["output"];
  /** True if using the Sandbox API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always FatZebra type. */
  type: PaymentsType;
  /** Verification hash. */
  verification: Scalars["String"]["output"];
};

/** FatZebra specific metadata about a gateway. */
export type FatZebraCardMetadata = PaymentsMetadata & {
  __typename?: "FatZebraCardMetadata";
  /** The full URL to direct post. */
  directPostUrl: Scalars["String"]["output"];
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** Configured redirection URL. */
  returnPath: Scalars["String"]["output"];
  /** True if using the Sandbox API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always FatZebra type. */
  type: PaymentsType;
  /** Verification hash. */
  verification: Scalars["String"]["output"];
};

/** FatZebra specific metadata about a gateway */
export type FatZebraMasterpassMetadata = PaymentsMetadata & {
  __typename?: "FatZebraMasterpassMetadata";
  /** URL to web page for managing MasterPass. */
  masterpassManageUrl?: Maybe<Scalars["String"]["output"]>;
  /** URL to web page for pairing MasterPass. */
  masterpassPairingUrl?: Maybe<Scalars["String"]["output"]>;
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** True if using the Sandbox API. */
  sandbox: Scalars["Boolean"]["output"];
  /** Always FatZebra type. */
  type: PaymentsType;
};

/** Represents a feature flag key/value pair */
export type FeatureFlag = {
  __typename?: "FeatureFlag";
  enabled: Scalars["Boolean"]["output"];
  key: Scalars["String"]["output"];
};

export enum FulfillmentType {
  Delivery = "DELIVERY",
  PickUp = "PICK_UP",
  Service = "SERVICE",
}

/** Minimal RedeemCode response */
export type GenericMessageDetails = MessageDetails & {
  __typename?: "GenericMessageDetails";
  message: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export enum InputType {
  Datepicker = "DATEPICKER",
  Keyboard = "KEYBOARD",
  List = "LIST",
  /** The user should input a valid store/location based on merchant locations */
  LocationSelector = "LOCATION_SELECTOR",
  Toggle = "TOGGLE",
}

export type IntKeyValue = KeyValue & {
  __typename?: "IntKeyValue";
  dataType: ValueType;
  intValue?: Maybe<Scalars["Int"]["output"]>;
  key: Scalars["String"]["output"];
  value?: Maybe<Scalars["String"]["output"]>;
};

export type InventoryItem = {
  __typename?: "InventoryItem";
  /** Display text that represents the code for this item. This will typically be the contents of the QR code or barcode. */
  codeText?: Maybe<Scalars["String"]["output"]>;
  /** URL to a code (barcode/QR code/etc) that represents this inventory item. */
  codeUrl?: Maybe<Scalars["String"]["output"]>;
  /** When the item was gifted to, or purchased by, the customer. */
  created: Scalars["Date"]["output"];
  /** When the item expires. */
  expires?: Maybe<Scalars["Date"]["output"]>;
  /** Unique ID of the item - use this with the item collection process. */
  id: Scalars["String"]["output"];
  /**
   * Image to display when viewing the item (not currently in use, but it's coming).
   * Width and height will be applied if possible via image resizer.
   */
  imageUrl?: Maybe<Scalars["URI"]["output"]>;
  /**
   * Will return a URL template for an image with the follwing fields.
   * w - width of image
   * h - height of image
   * fit - resizing stratergy to use.
   *
   * Note these fields are not guaranteed to be on the template.
   */
  imageUrlTemplate?: Maybe<Scalars["URITemplate"]["output"]>;
  /** Whether the item was a purchase or not. */
  purchased: Scalars["Boolean"]["output"];
  /** Text to display with the item (title in Saved Offers list). */
  title: Scalars["String"]["output"];
  /** The type currently has COLLECTION and CODE. */
  type: InventoryType;
};

export type InventoryItemImageUrlArgs = {
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum InventoryType {
  /** The inventory has a barcode */
  Code = "CODE",
  /** The inventory is a normal promotion */
  Collection = "COLLECTION",
}

export type Item = {
  __typename?: "Item";
  claimed?: Maybe<Scalars["Date"]["output"]>;
  claimedLocation?: Maybe<Scalars["String"]["output"]>;
  expires?: Maybe<Scalars["Date"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ItemAffectedRef = {
  index: Scalars["Int"]["input"];
  quantity: Scalars["Int"]["input"];
};

export type ItemExpiredActivity = Activity & {
  __typename?: "ItemExpiredActivity";
  /** Unique ID */
  id: Scalars["String"]["output"];
  /** Item */
  item: Item;
  /** Location if relevant for the event */
  locationName?: Maybe<Scalars["String"]["output"]>;
  /** Event time */
  timestamp: Scalars["Date"]["output"];
  /** Title */
  title: Scalars["String"]["output"];
};

/** Represents an order passed from the Tidy Javascript Payment Interface (eg: pre-orders) */
export type JsInterfaceOrder = {
  /** Optionally limits the payment to a specific client */
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  /** Option items metadata */
  items?: InputMaybe<Array<InputMaybe<JsInterfaceOrderItem>>>;
  /** The Aston ID of the merchant to be charged for this order. This is REQUIRED unless an orderStoreId is provided. */
  merchantId?: InputMaybe<Scalars["String"]["input"]>;
  /** Optional reference ID (order ID, check ID, invoice ID). Only used for metadata. */
  orderRef?: InputMaybe<Scalars["String"]["input"]>;
  /** The third party store ID of the store to be charged for this order. This will only work if the store-merchant mapping has been set up correctly. */
  orderStoreId?: InputMaybe<Scalars["String"]["input"]>;
  /** Total amount of tax included in the order IN DOLLARS. (Optional) */
  tax?: InputMaybe<Scalars["Float"]["input"]>;
  /** Optional title of the order. will be displayed to the user in the prompt. */
  title?: InputMaybe<Scalars["String"]["input"]>;
  /** Total amount of the order INCLUSIVE OF TAX in DOLLARS. */
  total: Scalars["Float"]["input"];
};

export type JsInterfaceOrderItem = {
  amount: Scalars["Float"]["input"];
  name: Scalars["String"]["input"];
  quantity: Scalars["Int"]["input"];
  tax?: InputMaybe<Scalars["Float"]["input"]>;
};

export type KeyValue = {
  /** The value type */
  dataType: ValueType;
  /** String key for the key value pair */
  key: Scalars["String"]["output"];
  /** String representation of the value (numbers and booleans are also represented as strings) */
  value?: Maybe<Scalars["String"]["output"]>;
};

export enum KeyboardType {
  Default = "DEFAULT",
  DefaultMasked = "DEFAULT_MASKED",
  Email = "EMAIL",
  Number = "NUMBER",
  NumberMasked = "NUMBER_MASKED",
  Phone = "PHONE",
}

export type LegalItem = {
  __typename?: "LegalItem";
  title: Scalars["String"]["output"];
  url: Scalars["URI"]["output"];
};

export type Location = {
  __typename?: "Location";
  address?: Maybe<Address>;
  billsEnabled: Scalars["Boolean"]["output"];
  coords?: Maybe<Coords>;
  distance?: Maybe<Scalars["Float"]["output"]>;
  externalMenuUrl?: Maybe<Scalars["String"]["output"]>;
  hasPayments: Scalars["Boolean"]["output"];
  id: Scalars["String"]["output"];
  /** The code a user must enter to initialise item collection. NOTE: will be null if legacy "staff-must-press" flow should be used. */
  itemCollectionCode?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  openingHours?: Maybe<Scalars["String"]["output"]>;
  orderAheadEnabled: Scalars["Boolean"]["output"];
  orderAtTableEnabled: Scalars["Boolean"]["output"];
  orderDeliveryEnabled: Scalars["Boolean"]["output"];
  paymentOptions: Array<PaymentOption>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  preorder?: Maybe<LocationPreorder>;
  slug?: Maybe<Scalars["String"]["output"]>;
  social?: Maybe<LocationSocialLinks>;
  timezone: Scalars["String"]["output"];
  uid: Scalars["String"]["output"];
  website?: Maybe<Scalars["String"]["output"]>;
};

export type LocationPreorder = {
  __typename?: "LocationPreorder";
  id: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type LocationSocialLinks = {
  __typename?: "LocationSocialLinks";
  facebook?: Maybe<Scalars["String"]["output"]>;
  instagram?: Maybe<Scalars["String"]["output"]>;
  twitter?: Maybe<Scalars["String"]["output"]>;
  yelp?: Maybe<Scalars["String"]["output"]>;
  youtube?: Maybe<Scalars["String"]["output"]>;
};

export enum LoginProvider {
  Apple = "APPLE",
  Email = "EMAIL",
  Facebook = "FACEBOOK",
  Google = "GOOGLE",
  Link = "LINK",
}

/** Available actions for menu items */
export enum MenuAction {
  /** App tour (no longer a feature) */
  AppTour = "APP_TOUR",
  /** Open a URL in the external browser */
  Browser = "BROWSER",
  /** Display the card list screen (home screen) */
  CardList = "CARD_LIST",
  /** Display the contact screen */
  Contact = "CONTACT",
  /** Open a URL in the embedded web screen */
  Embedded = "EMBEDDED",
  /** Open the history screen (My Activity) */
  History = "HISTORY",
  /** Display the payment screen (payment methods / wallet) */
  Payment = "PAYMENT",
  /** Display the user profile screen (profile view/edit) */
  Profile = "PROFILE",
  /** Register a new user */
  Register = "REGISTER",
  /** Display the saved offers screen */
  SavedOffers = "SAVED_OFFERS",
  /** Display the settings scren */
  Settings = "SETTINGS",
  /** Display the support screen */
  Support = "SUPPORT",
  /** Display the vouchers screen (voucher code entry) */
  Vouchers = "VOUCHERS",
  /** Open a URL in the internal / web view browser */
  Webview = "WEBVIEW",
}

export type MenuItem = {
  __typename?: "MenuItem";
  action?: Maybe<MenuAction>;
  iconUrl?: Maybe<Scalars["String"]["output"]>;
  params?: Maybe<Array<KeyValue>>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type MenuProductItem = ProductItem & {
  __typename?: "MenuProductItem";
  amount: Scalars["Int"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  /** may differ from the standard product amount */
  displayAmount: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  options: Array<ProductOption>;
  tags: Array<Scalars["String"]["output"]>;
};

export type MenuV2 = {
  __typename?: "MenuV2";
  categories?: Maybe<Array<ProductCategoryV2>>;
  fulfillmentType?: Maybe<Array<FulfillmentType>>;
  id: Scalars["String"]["output"];
  serviceAvailability?: Maybe<Array<Period>>;
  title: Scalars["String"]["output"];
};

/** A merchant represents the merchant for an entire application. */
export type Merchant = {
  __typename?: "Merchant";
  /** Link to App on Google Play Store */
  androidStoreUrl?: Maybe<Scalars["String"]["output"]>;
  /** Apple web client id for merchant */
  appleWebClientId?: Maybe<Scalars["String"]["output"]>;
  /** Currency code. */
  currency: Scalars["String"]["output"];
  /** Currency decimal digits, eg 2 for AUD/USD, 0 for JPY. */
  currencyDecimalDigits: Scalars["Int"]["output"];
  /** Maps a external location ref to matching Location */
  externalLocation?: Maybe<Location>;
  /** Google Client Id for this merchant (optionally). */
  googleClientId?: Maybe<Scalars["String"]["output"]>;
  /** Hide Google Pay (currently app only) */
  googlePayDisabled: Scalars["Boolean"]["output"];
  googleTagId?: Maybe<Scalars["String"]["output"]>;
  /** The unique ID for the merchant (integer as string). */
  id: Scalars["String"]["output"];
  /** Link to App on ios Store */
  iosStoreUrl?: Maybe<Scalars["String"]["output"]>;
  location?: Maybe<Location>;
  /** Locations/stores/sites for this merchant, optionally sorted by distance to myLocation. */
  locations?: Maybe<Array<Location>>;
  /** Meta Pixel ID for pixel tracking/analytics */
  metaPixelId?: Maybe<Scalars["String"]["output"]>;
  /** Display name of the merchant. */
  name: Scalars["String"]["output"];
  /**
   * Custom name of merchant receiving payment
   * This might be displayed when customer is confirming payment in apple/google pay
   */
  payName?: Maybe<Scalars["String"]["output"]>;
  /**
   * Metadata about the configured payment gateway.
   * @deprecated We only support Stripe now. Use stripePublishableKey.
   */
  paymentsMetadata?: Maybe<PaymentsMetadata>;
  /**
   * DEPRECATED Payment client token (eg: Braintree client token).
   * @deprecated This was for legacy Braintree. Use stripePublishableKey.
   */
  paymentsToken?: Maybe<Scalars["String"]["output"]>;
  /** Settings defined for this merchant. */
  settings: MerchantSettings;
  /** Merchant name in stripe */
  stripeMerchantName: Scalars["String"]["output"];
  /** Publishable/public Key to use for stripe */
  stripePublishableKey?: Maybe<Scalars["String"]["output"]>;
  /** The unique UID for the merchant. */
  uid: Scalars["String"]["output"];
};

/** A merchant represents the merchant for an entire application. */
export type MerchantExternalLocationArgs = {
  ref: Scalars["String"]["input"];
};

/** A merchant represents the merchant for an entire application. */
export type MerchantLocationArgs = {
  locationRef: Scalars["String"]["input"];
};

/** A merchant represents the merchant for an entire application. */
export type MerchantLocationsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  myLocation?: InputMaybe<CoordsInput>;
  nativeOrderingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MerchantSettings = {
  __typename?: "MerchantSettings";
  authEndpoint?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated we no longer use bluedot */
  bluedotAPIKey?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated we no longer use bluedot */
  bluedotPackageName?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated we no longer use bluedot */
  bluedotUsername?: Maybe<Scalars["String"]["output"]>;
  btnPayInStore: Scalars["String"]["output"];
  btnPreorder: Scalars["String"]["output"];
  externalOrderingUrl?: Maybe<Scalars["String"]["output"]>;
  loginProviders: Array<LoginProvider>;
  requirePhoneWeb: Scalars["Boolean"]["output"];
  requireVerification: Scalars["Boolean"]["output"];
  /** @deprecated use location payment options */
  showPayButton: Scalars["Boolean"]["output"];
  showScanCode?: Maybe<Scalars["Boolean"]["output"]>;
  termsAndConditionsURL: Scalars["String"]["output"];
  tipRatios: Array<Scalars["Float"]["output"]>;
};

export type Message = {
  __typename?: "Message";
  text?: Maybe<Scalars["String"]["output"]>;
  timestamp?: Maybe<Scalars["Date"]["output"]>;
};

export type MessageActivity = Activity & {
  __typename?: "MessageActivity";
  /** The message body */
  body: Scalars["String"]["output"];
  /** Unique ID */
  id: Scalars["String"]["output"];
  /** This is always null for messages at present */
  locationName?: Maybe<Scalars["String"]["output"]>;
  /** The timestamp of the message */
  timestamp: Scalars["Date"]["output"];
  /** The message title */
  title: Scalars["String"]["output"];
};

/** Minimum information that will be provided by RedeemCode */
export type MessageDetails = {
  message: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

/** Standard response for a mutation + a message */
export type MessageMutationResult = MutationResult & {
  __typename?: "MessageMutationResult";
  /** If unsuccessful this will be set and indicates why the mutation failed. Will be null if successful. */
  error?: Maybe<MutationError>;
  /** Success message to be displayed to the user. Will be null if there is an error. */
  message?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  /** DEPRECATED. Adds a new payment method */
  addPaymentMethod: PaymentMethod;
  /** Adds a new payment method */
  addPaymentMethodV2: PaymentMethodResult;
  /** Adds or connects a third party wallet, eg: MasterPass, PayLah */
  addWallet: AddWalletResult;
  associatePaymentMethod: StandardMutationResult;
  /** DEPRECATED. Authorizes a payment for the provided amount. Provide at least one identifier for locations. This method accept */
  authorizePayment: AuthorizedPayment;
  /** Authorizes a payment for the provided amount. Provide at least one identifier for locations. This method accept */
  authorizePaymentV2: AuthorizePaymentResult;
  /** Cancels an incomplete bill payment initialized using createBillPayment. */
  cancelBillPayment: StandardMutationResult;
  /** Cancels an incomplete order initialized using createOrder. */
  cancelOrder: StandardMutationResult;
  /** Cancel a previously started (but not completed) promotion redemption */
  cancelPromotionRedemption: StandardMutationResult;
  /** Cancel an existing Stripe setup intent if no longer required */
  cancelSetupIntent: StandardMutationResult;
  /**
   * Check in to a location using the specified payment method, optionally specify a limit (if required for this location)
   * @deprecated Replaced by checkInToV2
   */
  checkInTo: CheckIn;
  /** Check in to a location using the specified payment method, optionally specify a limit (if required for this location) */
  checkInToV2: CheckInResult;
  /** DEPRECATED. Check out of the location. */
  checkOutOf: CheckOutResultV1;
  /** Check out of the location */
  checkOutOfV2: CheckOutResult;
  /** Single mutation to start and finish promotion redemption. Don't use with paid promotions */
  claimPromotion: StandardMutationResult;
  completeBillPayment: TableBillMutationResult;
  /** Completes an order initialized using createOrder. */
  completeOrder: StandardMutationResult;
  /** Complete the customer promotion (incl. payment) */
  completePromotionRedemption: StandardMutationResult;
  /** Confirm an existing Stripe setup intent has been completed */
  confirmSetupIntent: PaymentMethodResult;
  createBillPayment: CreateBillPaymentResult;
  /** Starts a session for an order. If no payment method is provided the user will have to attach it to the session later. */
  createOrder: CreateOrderResult;
  /** Create a new Stripe setup intent to save a payment method */
  createSetupIntent: SetupIntentResult;
  /** Requests for the authenticated user's profile to be deleted */
  deleteProfile: MessageMutationResult;
  /** Pushes an order ahead order to the terminal. NOTE: total is the expected total. An error will occur if this does not match. NOTE2: a nonce for a payment must be provided - see authorizePaymentV2 to get this. */
  placeOrder: StandardMutationResult;
  /** DEPRECATED. Adds a new payment method */
  rateLocation: Scalars["Boolean"]["output"];
  /** Adds a new payment method */
  rateLocationV2: StandardMutationResult;
  /** redeem voucher Code */
  redeemCode: RedeemCodeResult;
  /** DEPRECATED. Adds a new payment method */
  removePaymentMethod: Scalars["Boolean"]["output"];
  /** Adds a new payment method */
  removePaymentMethodV2: StandardMutationResult;
  /** Send verification code to mobile number via sms */
  requestPhoneNumberVerification: StandardMutationResult;
  /** Starts the promotion redemption flow for paid promotions */
  startPromotionRedemption: StartPromotionRedemptionResult;
  /** Updates the tip amount on a bill */
  updateBillTip: StandardMutationResult;
  /** DEPRECATED. Updates the payment method used for this location */
  updateCheckIn: CheckIn;
  /** Updates the payment method used for this location */
  updateCheckInV2: CheckInResult;
  /** Updates the tip amount on an order */
  updateOrderTip: StandardMutationResult;
  /** Verify phone number based on code send via sms */
  verifyPhoneNumber: StandardMutationResult;
};

export type MutationAddPaymentMethodArgs = {
  details: PaymentMethodInput;
};

export type MutationAddPaymentMethodV2Args = {
  details: PaymentMethodInput;
};

export type MutationAddWalletArgs = {
  details: AddWalletInput;
};

export type MutationAssociatePaymentMethodArgs = {
  token: Scalars["String"]["input"];
};

export type MutationAuthorizePaymentArgs = {
  cardId: Scalars["String"]["input"];
  order: JsInterfaceOrder;
};

export type MutationAuthorizePaymentV2Args = {
  cardId: Scalars["String"]["input"];
  order: JsInterfaceOrder;
};

export type MutationCancelBillPaymentArgs = {
  id: Scalars["String"]["input"];
};

export type MutationCancelOrderArgs = {
  id: Scalars["String"]["input"];
};

export type MutationCancelPromotionRedemptionArgs = {
  orderId: Scalars["String"]["input"];
};

export type MutationCancelSetupIntentArgs = {
  intentId: Scalars["String"]["input"];
};

export type MutationCheckInToArgs = {
  autoCheckOut?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  location: Scalars["String"]["input"];
  paymentMethod: Scalars["String"]["input"];
};

export type MutationCheckInToV2Args = {
  autoCheckOut?: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  location: Scalars["String"]["input"];
  paymentMethod: Scalars["String"]["input"];
};

export type MutationCheckOutOfArgs = {
  location: Scalars["String"]["input"];
};

export type MutationCheckOutOfV2Args = {
  location: Scalars["String"]["input"];
};

export type MutationClaimPromotionArgs = {
  locationId?: InputMaybe<Scalars["String"]["input"]>;
  promotionId: Scalars["String"]["input"];
};

export type MutationCompleteBillPaymentArgs = {
  id: Scalars["String"]["input"];
};

export type MutationCompleteOrderArgs = {
  externalPayment?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["String"]["input"];
};

export type MutationCompletePromotionRedemptionArgs = {
  locationId: Scalars["String"]["input"];
  orderId: Scalars["String"]["input"];
};

export type MutationConfirmSetupIntentArgs = {
  intentId: Scalars["String"]["input"];
};

export type MutationCreateBillPaymentArgs = {
  amount: Scalars["Int"]["input"];
  billId: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
  location: Scalars["String"]["input"];
  tip?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MutationCreateOrderArgs = {
  deliveryAddress?: InputMaybe<DeliveryAddress>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  items: Array<OrderAheadItem>;
  location: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  paymentMethodId?: InputMaybe<Scalars["String"]["input"]>;
  ref?: InputMaybe<Scalars["String"]["input"]>;
  serviceRef?: InputMaybe<Scalars["String"]["input"]>;
  timeSlot?: InputMaybe<Scalars["String"]["input"]>;
  tip?: InputMaybe<Scalars["Int"]["input"]>;
  total: Scalars["Int"]["input"];
};

export type MutationPlaceOrderArgs = {
  cardId: Scalars["String"]["input"];
  deliveryAddress?: InputMaybe<DeliveryAddress>;
  items: Array<OrderAheadItem>;
  location: Scalars["String"]["input"];
  notes?: InputMaybe<Scalars["String"]["input"]>;
  table?: InputMaybe<Scalars["String"]["input"]>;
  total: Scalars["Int"]["input"];
};

export type MutationRateLocationArgs = {
  location: Scalars["String"]["input"];
  rating: Scalars["Int"]["input"];
};

export type MutationRateLocationV2Args = {
  location: Scalars["String"]["input"];
  rating: Scalars["Int"]["input"];
};

export type MutationRedeemCodeArgs = {
  code: Scalars["String"]["input"];
};

export type MutationRemovePaymentMethodArgs = {
  paymentMethod: Scalars["String"]["input"];
};

export type MutationRemovePaymentMethodV2Args = {
  paymentMethod: Scalars["String"]["input"];
};

export type MutationRequestPhoneNumberVerificationArgs = {
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationStartPromotionRedemptionArgs = {
  locationId: Scalars["String"]["input"];
  promotionId: Scalars["String"]["input"];
};

export type MutationUpdateBillTipArgs = {
  id: Scalars["String"]["input"];
  tip: Scalars["Int"]["input"];
};

export type MutationUpdateCheckInArgs = {
  location: Scalars["String"]["input"];
  paymentMethod: Scalars["String"]["input"];
};

export type MutationUpdateCheckInV2Args = {
  location: Scalars["String"]["input"];
  paymentMethod: Scalars["String"]["input"];
};

export type MutationUpdateOrderTipArgs = {
  id: Scalars["String"]["input"];
  tip: Scalars["Int"]["input"];
};

export type MutationVerifyPhoneNumberArgs = {
  verificationCode: Scalars["String"]["input"];
};

/** Represents an application level error while executing a mutation */
export type MutationError = {
  __typename?: "MutationError";
  /** Optional identifier of the error type for triggering custom behavior */
  code?: Maybe<Scalars["String"]["output"]>;
  /** The message for an error */
  message: Scalars["String"]["output"];
};

/** Mutation result with flag indicating success, and an error message in the event of failure */
export type MutationResult = {
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
};

export type OptionChoiceV2 = {
  __typename?: "OptionChoiceV2";
  defaultQuantity: Scalars["Int"]["output"];
  maxQuantity: Scalars["Int"]["output"];
  minQuantity: Scalars["Int"]["output"];
  product: ProductV2;
};

export type Order = {
  __typename?: "Order";
  billingType?: Maybe<Scalars["String"]["output"]>;
  created: Scalars["Date"]["output"];
  creditAmount: Scalars["Int"]["output"];
  currency: Scalars["String"]["output"];
  customerFeeAmount: Scalars["Int"]["output"];
  deliveryAddress?: Maybe<AddressDelivery>;
  /** @deprecated We should move away from this approach, Activity should be about the past not the future. Details on live orders can be handled separately. */
  deliveryAtMax?: Maybe<Scalars["Date"]["output"]>;
  /** @deprecated We should move away from this approach, Activity should be about the past not the future. Details on live orders can be handled separately. */
  deliveryAtMin?: Maybe<Scalars["Date"]["output"]>;
  discounts?: Maybe<Array<Maybe<OrderModifier>>>;
  estimatedReadyAt?: Maybe<Scalars["Date"]["output"]>;
  event: PosEvent;
  externalAmount: Scalars["Int"]["output"];
  fulfillAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  itemTax?: Maybe<Scalars["Int"]["output"]>;
  itemTotal: Scalars["Int"]["output"];
  items: Array<OrderItem>;
  location?: Maybe<Location>;
  modifiers?: Maybe<Array<Maybe<OrderModifier>>>;
  orderAcceptedAt?: Maybe<Scalars["Date"]["output"]>;
  paymentId?: Maybe<Scalars["String"]["output"]>;
  paymentMethodIconUrl?: Maybe<Scalars["String"]["output"]>;
  paymentMethodName?: Maybe<Scalars["String"]["output"]>;
  paymentMethodType?: Maybe<Scalars["String"]["output"]>;
  points?: Maybe<Scalars["Int"]["output"]>;
  refId: Scalars["String"]["output"];
  serviceRef?: Maybe<Scalars["String"]["output"]>;
  tax?: Maybe<Scalars["Int"]["output"]>;
  tipAmount?: Maybe<Scalars["Int"]["output"]>;
  total: Scalars["Int"]["output"];
};

export type OrderAdjustment = {
  amount: Scalars["Int"]["input"];
  id: Scalars["String"]["input"];
  itemsAffected?: InputMaybe<Array<ItemAffectedRef>>;
  label: Scalars["String"]["input"];
  taxIncluded?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrderAheadChoice = {
  /** The ID of the selected choice */
  id: Scalars["String"]["input"];
  /** Option choices for this item. Set to null if no options. */
  options?: InputMaybe<Array<OrderAheadOption>>;
  /** Number of these items to order */
  quantity?: InputMaybe<Scalars["Int"]["input"]>;
  /** If a choice is unavailable */
  unavailable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a single item to be ordered */
export type OrderAheadItem = {
  /** The ID of the item to be ordered */
  id: Scalars["String"]["input"];
  /** Optionally specify a note for the product */
  note?: InputMaybe<Scalars["String"]["input"]>;
  /** Option choices for this item. Set to null if no options. */
  options?: InputMaybe<Array<OrderAheadOption>>;
  /** Number of these items to order */
  quantity: Scalars["Int"]["input"];
  /** If an item is unavailable */
  unavailable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type OrderAheadOption = {
  /** List of selected choices */
  choices: Array<OrderAheadChoice>;
  /** The ID of the option being set */
  id: Scalars["String"]["input"];
};

export type OrderCard = Card & {
  __typename?: "OrderCard";
  /** Unused */
  action?: Maybe<Action>;
  /** The status of this order as a string. */
  badgeText?: Maybe<Scalars["String"]["output"]>;
  /** Unused */
  details?: Maybe<Scalars["String"]["output"]>;
  /** ORDER */
  displayType?: Maybe<CardDisplayType>;
  estimatedReadyAt?: Maybe<Scalars["Date"]["output"]>;
  fulfillAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  /**
   * Unused
   * Width and height will be applied if possible via image resizer.
   */
  imageUrl?: Maybe<Scalars["URI"]["output"]>;
  imageUrlTemplate?: Maybe<Scalars["URITemplate"]["output"]>;
  infoText?: Maybe<Scalars["String"]["output"]>;
  /** Location name */
  locationName: Scalars["String"]["output"];
  /** Current state of this order. */
  state: OrderState;
  /** Time this order was created. */
  timestamp: Scalars["Date"]["output"];
  /** The order number. */
  title?: Maybe<Scalars["String"]["output"]>;
  /** Total cost of this order formatted. */
  totalFormatted: Scalars["String"]["output"];
};

export type OrderCardImageUrlArgs = {
  height?: InputMaybe<Scalars["Int"]["input"]>;
  width?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OrderChoice = {
  __typename?: "OrderChoice";
  amount: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  tax?: Maybe<Scalars["Int"]["output"]>;
};

/** Delivery details for ordering */
export type OrderDeliveryConfig = {
  __typename?: "OrderDeliveryConfig";
  /** The current status of ordering availability at this location. */
  active: Scalars["Boolean"]["output"];
  /** Whether to accept item notes */
  allowItemNotes: Scalars["Boolean"]["output"];
  /** Whether to accept order notes */
  allowOrderNotes: Scalars["Boolean"]["output"];
  /** If External Payments are enabled */
  externalPaymentEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** If External Voucher are enabled */
  externalVoucherEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * DEPRECATED. Cost of delivery in cents
   * @deprecated Use feePrice
   */
  feeAmount: Scalars["Int"]["output"];
  feePrice?: Maybe<Price>;
  /** Maximum characters item notes can have */
  itemNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** Minimum order amount for delivery in cents */
  minimumAmount: Scalars["Int"]["output"];
  /** Estimated max delivery time in minutes */
  minutesMax: Scalars["Int"]["output"];
  /** Estimated min delivery time in minutes */
  minutesMin: Scalars["Int"]["output"];
  /** Maximum characters order notes can have */
  orderNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** A list of post codes that can be delivered too */
  postcodes: Array<Scalars["String"]["output"]>;
  /** Timeslots for showing times */
  timeSlots?: Maybe<Array<TimeSlot>>;
  /** Which tip ratio to default to */
  tipDefaultIndex?: Maybe<Scalars["Int"]["output"]>;
  /** Tip ratios for pre-set tip amounts, ie: [0.1, 0.2, 0.3], if empty array don't show preset amounts */
  tipRatios: Array<Scalars["Float"]["output"]>;
  /** If Tips are enabled */
  tipsEnabled: Scalars["Boolean"]["output"];
};

export type OrderItem = {
  __typename?: "OrderItem";
  amount: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  options?: Maybe<Array<Maybe<OrderOption>>>;
  quantity: Scalars["Int"]["output"];
  tax?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderModifier = {
  __typename?: "OrderModifier";
  amount: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  tax?: Maybe<Scalars["Int"]["output"]>;
};

export type OrderOption = {
  __typename?: "OrderOption";
  choices: Array<Maybe<OrderChoice>>;
  name: Scalars["String"]["output"];
};

/** Pickup details for ordering */
export type OrderPickupConfig = {
  __typename?: "OrderPickupConfig";
  /** The current status of ordering availability at this location. */
  active: Scalars["Boolean"]["output"];
  /** Whether to accept item notes */
  allowItemNotes: Scalars["Boolean"]["output"];
  /** Whether to accept order notes */
  allowOrderNotes: Scalars["Boolean"]["output"];
  /** If External Payments are enabled */
  externalPaymentEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** If External Voucher are enabled */
  externalVoucherEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum characters item notes can have */
  itemNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum characters order notes can have */
  orderNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** Timeslots for showing times */
  timeSlots?: Maybe<Array<TimeSlot>>;
  /** Which tip ratio to default to */
  tipDefaultIndex?: Maybe<Scalars["Int"]["output"]>;
  /** Tip ratios for pre-set tip amounts, ie: [0.1, 0.2, 0.3], if empty array don't show preset amounts */
  tipRatios: Array<Scalars["Float"]["output"]>;
  /** If Tips are enabled */
  tipsEnabled: Scalars["Boolean"]["output"];
  /** Estimated wait time for new orders in minutes. */
  waitTime: Scalars["Int"]["output"];
};

/** "At table/room/etc" details for ordering */
export type OrderServiceConfig = {
  __typename?: "OrderServiceConfig";
  /** The current status of ordering availability at this location. */
  active: Scalars["Boolean"]["output"];
  /** Whether to accept item notes */
  allowItemNotes: Scalars["Boolean"]["output"];
  /** Whether to accept order notes */
  allowOrderNotes: Scalars["Boolean"]["output"];
  /** If External Payments are enabled */
  externalPaymentEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** If External Voucher are enabled */
  externalVoucherEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  /** Maximum characters item notes can have */
  itemNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** Maximum characters order notes can have */
  orderNotesMaxLength?: Maybe<Scalars["Int"]["output"]>;
  /** Service charge Label */
  serviceChargeLabel?: Maybe<Scalars["String"]["output"]>;
  /** Service charge rate, ie: 0.10 is 10%, do not show a service charge when 0 */
  serviceChargeRate?: Maybe<Scalars["Float"]["output"]>;
  /** Which tip ratio to default to */
  tipDefaultIndex?: Maybe<Scalars["Int"]["output"]>;
  /** Tip ratios for pre-set tip amounts, ie: [0.1, 0.2, 0.3], if empty array don't show preset amounts */
  tipRatios: Array<Scalars["Float"]["output"]>;
  /** If Tips are enabled */
  tipsEnabled: Scalars["Boolean"]["output"];
  /** A list of valid refs, typically table numbers for "order at table". No verification should take place if null. */
  validRefs?: Maybe<Array<OrderServiceRef>>;
  /** Estimated wait time for new orders in minutes. */
  waitTime: Scalars["Int"]["output"];
};

/** Represent a service reference such as a table number, room number, etc */
export type OrderServiceRef = {
  __typename?: "OrderServiceRef";
  /** Ref ID */
  ref: Scalars["String"]["output"];
};

export type OrderSession = {
  __typename?: "OrderSession";
  /** Amount of total allocated to credit */
  creditAmount: Scalars["Int"]["output"];
  /** Order currency code */
  currency: Scalars["String"]["output"];
  /** Amount of total allocated to discount */
  discountAmount: Scalars["Int"]["output"];
  /** The (session) order ID */
  id: Scalars["String"]["output"];
  /** Amount of total allocated to payment */
  paymentAmount: Scalars["Int"]["output"];
  /** Client secret of the Stripe payment intent for Stripe elements. Will be null if no payment amount. */
  paymentIntentSecret?: Maybe<Scalars["String"]["output"]>;
  /** If the order requires phone verification before being completed */
  requirePhoneVerification?: Maybe<Scalars["Boolean"]["output"]>;
  /** Array of label and value pairs */
  summaryItems: Array<SummaryItem>;
  /** Amount of the tip for the order. NOTE: this is provided in summaryItems too */
  tipAmount: Scalars["Int"]["output"];
};

export enum OrderState {
  /** The order could not be created, or was rejected */
  Failed = "FAILED",
  /** The order has been accepted, is being made, delivered, or anything in between NEW and SUCCESS */
  InProgress = "IN_PROGRESS",
  /** The order has been created, but has not yet been reviewed / accepted / rejected */
  New = "NEW",
  /** The order has been accepted and is being, or has been processed */
  Success = "SUCCESS",
}

/** Ordering data for a location */
export type Ordering = {
  __typename?: "Ordering";
  /**
   * Details for delivery (if available, else null)
   * @deprecated Use deliveryConfig
   */
  delivery?: Maybe<OrderDeliveryConfig>;
  deliveryAddressStatus?: Maybe<DeliveryAddressStatus>;
  /** Details for delivery (if available, else null) */
  deliveryConfig?: Maybe<OrderDeliveryConfig>;
  /** Order ahead product menu. Note: returns null if no menu available for this location. */
  menu?: Maybe<Array<ProductCategory>>;
  menuV2?: Maybe<MenuV2>;
  menus?: Maybe<Array<MenuV2>>;
  /** Details for pickup (if available, else null) */
  pickupConfig?: Maybe<OrderPickupConfig>;
  product?: Maybe<ProductV2>;
  /** Returns the most recent (accepted) carts for a customer at a location */
  recentCarts: Array<Cart>;
  /** Details for service ordering (table service, room service) (if available, else null) */
  serviceConfig?: Maybe<OrderServiceConfig>;
  /**
   * A list of valid table numbers for "order at table". Returns null if table numbers or order-at-table is not configured. No table verification should take place if null.
   * @deprecated Use validRefs specified under serviceConfig
   */
  tables?: Maybe<Array<Scalars["String"]["output"]>>;
  /**
   * Estimated wait time for new orders in minutes.
   * @deprecated Use times specified under delivery/pickup/ref
   */
  waitTime: Scalars["Int"]["output"];
};

/** Ordering data for a location */
export type OrderingDeliveryAddressStatusArgs = {
  address?: InputMaybe<DeliveryAddress>;
};

/** Ordering data for a location */
export type OrderingDeliveryConfigArgs = {
  to?: InputMaybe<CoordsInput>;
};

/** Ordering data for a location */
export type OrderingMenuArgs = {
  fulfillmentType?: InputMaybe<FulfillmentType>;
  selectedTimeSlot?: InputMaybe<Scalars["String"]["input"]>;
};

/** Ordering data for a location */
export type OrderingMenuV2Args = {
  menuId: Scalars["String"]["input"];
};

/** Ordering data for a location */
export type OrderingMenusArgs = {
  fulfillmentType?: InputMaybe<FulfillmentType>;
};

/** Ordering data for a location */
export type OrderingProductArgs = {
  plu?: InputMaybe<Scalars["String"]["input"]>;
  productId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Ordering data for a location */
export type OrderingRecentCartsArgs = {
  limit: Scalars["Int"]["input"];
};

export type OrderingPaymentOption = PaymentOption & {
  __typename?: "OrderingPaymentOption";
  action: PaymentAction;
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  /** ie: I'm collecting from */
  locationConfirmText?: Maybe<Scalars["String"]["output"]>;
  /** if null do not prompt for a ref (table/room number) */
  refPromptText?: Maybe<Scalars["String"]["output"]>;
  scanner: ScannerBehaviour;
  scannerTitle?: Maybe<Scalars["String"]["output"]>;
  waitTimeText?: Maybe<Scalars["String"]["output"]>;
};

export enum OrderingStatus {
  /** The store is currently offline and NOT accepting orders */
  Offline = "OFFLINE",
  /** The store is currently online and accepting orders */
  Online = "ONLINE",
}

/** Standardised pagination */
export type PageInfo = {
  __typename?: "PageInfo";
  endCursor: Scalars["String"]["output"];
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  startCursor: Scalars["String"]["output"];
};

export type Payment = {
  __typename?: "Payment";
  orderSession?: Maybe<OrderSession>;
  state: PaymentState;
};

/** Defines an action to take to load a spend option for a location. */
export enum PaymentAction {
  /** Check-in based in store payments. */
  CheckIn = "CHECK_IN",
  /** Order, pay and get it delivered! #COVID-19 */
  Delivery = "DELIVERY",
  /** Order ahead payments. */
  OrderAhead = "ORDER_AHEAD",
  /** Order at table payments. */
  OrderAtTable = "ORDER_AT_TABLE",
  /** Pay at table (or at terminal) payments. */
  PayAtTable = "PAY_AT_TABLE",
}

export type PaymentMethod = {
  __typename?: "PaymentMethod";
  /** Display string for this payment method. */
  displayText: Scalars["String"]["output"];
  /** DEPRECATED Expiry can also be retrieved as a timestamp, null for non credit card types. */
  expires?: Maybe<Scalars["Date"]["output"]>;
  /** DEPRECATED Expiry is only available for credit cards, null for other types. */
  expiry: Scalars["String"]["output"];
  /** Icon URL to display for the payment method. */
  iconUrl: Scalars["String"]["output"];
  /** The unique ID of this payment method. */
  id: Scalars["String"]["output"];
  /** Identifier display string for this payment method. */
  idText: Scalars["String"]["output"];
  /** DEPRECATED The display name for this payment method. */
  name: Scalars["String"]["output"];
  /** Surcharge rate (fee) that will apply to payments using this method. 0 if no surcharge. */
  surcharge: Scalars["Float"]["output"];
  /** DEPRECATED Payment method or credit card type (NOTE: maybe this should be an enum?). */
  type: Scalars["String"]["output"];
  /** Type display string for this payment method. */
  typeText: Scalars["String"]["output"];
  /** Wallet type the payment method belongs to ( dbs/ paylah / masterpass / null ). */
  walletType?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentMethodInput = {
  /** Braintree */
  nonce?: InputMaybe<Scalars["String"]["input"]>;
  /** DBS */
  requestId?: InputMaybe<Scalars["String"]["input"]>;
  /** FatZebra, Masterpass, Stripe */
  token?: InputMaybe<Scalars["String"]["input"]>;
  /** Cardstream */
  xref?: InputMaybe<Scalars["String"]["input"]>;
};

/** Payment method result extends a mutation result, but also provides the payment method in the event of success */
export type PaymentMethodResult = MutationResult & {
  __typename?: "PaymentMethodResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful provides the payment method data */
  paymentMethod?: Maybe<PaymentMethod>;
};

/** A spend option for a location defined a spend action available at a location. */
export type PaymentOption = {
  /**
   * Defines the actionable method to use for this spend option.
   * @deprecated logic should now be inferred from the type (__typename)
   */
  action: PaymentAction;
  id: Scalars["String"]["output"];
  /** Label for the action (to be used on buttons etc). */
  label: Scalars["String"]["output"];
};

/**
 * PaymentState is the same as OrdersV3.OrderState
 * This is not called OrderState because we already have that
 */
export enum PaymentState {
  Authorized = "authorized",
  Canceled = "canceled",
  Created = "created",
  Failed = "failed",
  Refunded = "refunded",
  Settled = "settled",
  Submitted = "submitted",
}

/** Metadata about a payment gateway */
export type PaymentsMetadata = {
  /** Display name for the gateway */
  name: Scalars["String"]["output"];
  /** Gateway type */
  type: PaymentsType;
};

/** The gateway type for payments */
export enum PaymentsType {
  /** Braintree using the v.zero drop in UI */
  BraintreeVzero = "BRAINTREE_VZERO",
  /** Cardstream (UK payment gateway) */
  Cardstream = "CARDSTREAM",
  /** DBS: credit cards and PayLah */
  Dbs = "DBS",
  /** DBS: credit cards only (wirecard) */
  DbsCard = "DBS_CARD",
  /** FatZebra using credit cards only */
  FatzebraCard = "FATZEBRA_CARD",
  /** FatZebra using both credit cards and Masterpass */
  FatzebraCardMasterpass = "FATZEBRA_CARD_MASTERPASS",
  /** FatZebra using Masterpass only */
  FatzebraMasterpass = "FATZEBRA_MASTERPASS",
  /** Stripe (legacy Stripe integration) */
  Stripe = "STRIPE",
  /** Stripe Connect */
  StripeConnect = "STRIPE_CONNECT",
}

export type Period = {
  __typename?: "Period";
  dayOfTheWeek: DayOfTheWeek;
  end: Scalars["String"]["output"];
  start: Scalars["String"]["output"];
};

export type PointsActivity = Activity & {
  __typename?: "PointsActivity";
  /** Unique ID */
  id: Scalars["String"]["output"];
  /** Location is always null */
  locationName?: Maybe<Scalars["String"]["output"]>;
  /** Points adjusted */
  points: Scalars["Int"]["output"];
  /** Formatted version of points adjusted */
  pointsText: Scalars["String"]["output"];
  /** Adjustment time */
  timestamp: Scalars["Date"]["output"];
  /** Comment for adjustment */
  title: Scalars["String"]["output"];
};

export type PosEvent = {
  __typename?: "PosEvent";
  message: Scalars["String"]["output"];
  timestamp: Scalars["Date"]["output"];
  tone: Tone;
};

export type Price = {
  __typename?: "Price";
  amount: Scalars["Int"]["output"];
  taxIncluded?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a category of products available to order. */
export type ProductCategory = {
  __typename?: "ProductCategory";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  products: Array<MenuProductItem>;
};

export type ProductCategoryV2 = {
  __typename?: "ProductCategoryV2";
  id: Scalars["String"]["output"];
  /** Optionally restrict resulting products to the provided IDs to reduce response payload size */
  products?: Maybe<Array<ProductV2>>;
  title: Scalars["String"]["output"];
};

export type ProductCategoryV2ProductsArgs = {
  productIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ProductChoice = {
  __typename?: "ProductChoice";
  amount: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  /** True if this choice should be selected by default. */
  selected: Scalars["Boolean"]["output"];
};

export type ProductItem = {
  amount: Scalars["Int"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  /** may differ from the standard product amount */
  displayAmount: Scalars["Int"]["output"];
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  options?: Maybe<Array<Maybe<ProductOption>>>;
  tags: Array<Scalars["String"]["output"]>;
};

export type ProductOption = {
  __typename?: "ProductOption";
  choices: Array<ProductChoice>;
  id: Scalars["String"]["output"];
  maxSelect?: Maybe<Scalars["Int"]["output"]>;
  minSelect: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
};

export type ProductOptionV2 = {
  __typename?: "ProductOptionV2";
  choices: Array<OptionChoiceV2>;
  id: Scalars["String"]["output"];
  maxQuantity?: Maybe<Scalars["Int"]["output"]>;
  minQuantity: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
};

export type ProductV2 = {
  __typename?: "ProductV2";
  available: Scalars["Boolean"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  options: Array<ProductOptionV2>;
  plu?: Maybe<Scalars["String"]["output"]>;
  price: Price;
  tags: Array<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  visibility?: Maybe<Array<Period>>;
};

export type ProfileItem = {
  __typename?: "ProfileItem";
  dataType?: Maybe<ProfileItemDataType>;
  field?: Maybe<Scalars["String"]["output"]>;
  formattedLabel?: Maybe<Scalars["String"]["output"]>;
  inputType?: Maybe<InputType>;
  keyboardType?: Maybe<KeyboardType>;
  label?: Maybe<Scalars["String"]["output"]>;
  maxLength?: Maybe<Scalars["Int"]["output"]>;
  minLength?: Maybe<Scalars["Int"]["output"]>;
  options?: Maybe<Array<ProfileItemOption>>;
  required?: Maybe<Scalars["Boolean"]["output"]>;
  type?: Maybe<ProfileItemType>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export enum ProfileItemDataType {
  Boolean = "BOOLEAN",
  Date = "DATE",
  Integer = "INTEGER",
  String = "STRING",
}

export type ProfileItemOption = {
  __typename?: "ProfileItemOption";
  label?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export enum ProfileItemType {
  Barcode = "BARCODE",
  BirthDate = "BIRTH_DATE",
  Date = "DATE",
  Datetime = "DATETIME",
  Default = "DEFAULT",
  Divider = "DIVIDER",
  Email = "EMAIL",
  FirstName = "FIRST_NAME",
  LastName = "LAST_NAME",
  Legal = "LEGAL",
  /** Store / site / location */
  Location = "LOCATION",
  Options = "OPTIONS",
  Password = "PASSWORD",
  Phone = "PHONE",
  Points = "POINTS",
  Postcode = "POSTCODE",
  PrimaryEmail = "PRIMARY_EMAIL",
  PrimaryPhone = "PRIMARY_PHONE",
  Terms = "TERMS",
  Tick = "TICK",
}

export enum ProfileScope {
  Create = "CREATE",
  Read = "READ",
  Update = "UPDATE",
}

/** Promotion */
export type Promotion = {
  __typename?: "Promotion";
  details: Scalars["String"]["output"];
  price?: Maybe<Scalars["Int"]["output"]>;
  priceType?: Maybe<PromotionPriceType>;
  title: Scalars["String"]["output"];
};

export type PromotionActivity = Activity & {
  __typename?: "PromotionActivity";
  /** Credit received if any */
  credit?: Maybe<Credit>;
  /** Unique ID */
  id: Scalars["String"]["output"];
  /** Item received if any */
  item?: Maybe<Item>;
  /** Location is always null for now */
  locationName?: Maybe<Scalars["String"]["output"]>;
  /** Related order if there was one */
  order?: Maybe<Order>;
  /** Points received (spend or gift or both) */
  points: Scalars["Int"]["output"];
  pointsText: Scalars["String"]["output"];
  /** Promotion */
  promotion: Promotion;
  /** Promotion redemption time */
  timestamp: Scalars["Date"]["output"];
  /** Promotion event title */
  title: Scalars["String"]["output"];
};

export enum PromotionDisplayType {
  ImageOnly = "IMAGE_ONLY",
  ImageWithDescription = "IMAGE_WITH_DESCRIPTION",
  NoImage = "NO_IMAGE",
}

export type PromotionLocation = {
  __typename?: "PromotionLocation";
  id: Scalars["String"]["output"];
};

export enum PromotionPriceType {
  Dollars = "DOLLARS",
  None = "NONE",
  Points = "POINTS",
}

export enum PromotionRewardType {
  Credit = "CREDIT",
  Discount = "DISCOUNT",
  Item = "ITEM",
  List = "LIST",
  Points = "POINTS",
  Webhook = "WEBHOOK",
}

export enum PromotionType {
  Code = "CODE",
  Gift = "GIFT",
  Info = "INFO",
  Spend = "SPEND",
  Web = "WEB",
}

export type QrCode = {
  __typename?: "QRCode";
  content: Scalars["String"]["output"];
  image: Scalars["String"]["output"];
};

export type Query = {
  __typename?: "Query";
  /** All activity for the logged on user - messages (broadcast), spend, redemptions, collections. */
  activity: ActivityResult;
  /** Address lookup, returns null of no matching address found */
  address: Array<AddressDetails>;
  /**
   * Address auto complete, returns name and ref
   * It is intended that locationRef will become mandatory in the future once all implementations are sending the locationRef
   */
  addressAutocomplete: Array<AddressAutocomplete>;
  /** Resolves auto complete ref to AddressDetails */
  addressDetails: AddressDetailsResponse;
  /**
   * formatted balances
   * @deprecated To support multiple discounts in the future, use discounts.
   */
  balance: Balance;
  /** Return table bill for this customer if available. Return null if no available table bill for this location's table number. */
  bill?: Maybe<TableBill>;
  billPaymentConfig?: Maybe<BillPaymentConfig>;
  /** List of card details for the home screen (accessible without access token). */
  cards?: Maybe<Array<Card>>;
  /** Gets check in details if available currently at this location (ie: in-store payments check in). Will return empty array if no/null location. */
  checkIn?: Maybe<CheckIn>;
  /** discount */
  discount?: Maybe<Discount>;
  /** discounts */
  discounts?: Maybe<Array<Discount>>;
  /** If this returns null keep routing to the internal app url */
  embeddedUrl?: Maybe<Scalars["String"]["output"]>;
  /** Feature flags */
  features: Array<FeatureFlag>;
  /** legals */
  legals?: Maybe<Array<LegalItem>>;
  /** Returns details about me - the currently logged on user. */
  me?: Maybe<Customer>;
  /**
   * DEPRECATED. Use menuItems.
   * @deprecated Use menuItems
   */
  menu?: Maybe<Array<MenuItem>>;
  /** Items to be listed for the side menu (accessible without access token). Note this will change when a user's state changes. */
  menuItems: Array<MenuItem>;
  /** Returns information about the merchant associated with this user or application key (accessible without access token). */
  merchant: Merchant;
  /**
   * DEPRECATED Messages (from Broadcast) sent to this user.
   * @deprecated Use activity
   */
  messages: Array<Message>;
  order?: Maybe<Order>;
  /** Ordering data such as wait time, product menu, table numbers and bills. Note: returns null if not enabled for this location. */
  ordering?: Maybe<Ordering>;
  payment?: Maybe<Payment>;
  /** Profile fields available to for sign up, profile view, and profile edit. */
  profileFields?: Maybe<Array<ProfileItem>>;
  /** List of promotion details for web promotions tab screen */
  promotions?: Maybe<Array<WebPromotion>>;
  /** Resolves single reward based on id (eg 1234:RewardCredit) */
  reward?: Maybe<Reward>;
  /** Resolves rewards available for customer */
  rewards?: Maybe<RewardResult>;
  /** Returns information about the session for this user. */
  session?: Maybe<Session>;
  /**
   * DEPRECATED Returns spend history for this customer if available. Returns null if this customer does not have payments. Specify transactionId to filter for a specific transaction. Will return empty array if no matched transaction.
   * @deprecated Use activity
   */
  spendHistory: Array<SpendHistoryItem>;
  /**
   * Gets the spend options available at the selected location (eg in-store and order ahead).
   * @deprecated Use merchant->location->paymentOptions instead
   */
  spendOptions: Array<SpendOption>;
  /** Returns formatted strings for various in app uses. */
  strings?: Maybe<Strings>;
  webLinks: Array<WebLink>;
};

export type QueryActivityArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAddressArgs = {
  query: Scalars["String"]["input"];
};

export type QueryAddressAutocompleteArgs = {
  locationRef?: InputMaybe<Scalars["String"]["input"]>;
  query: Scalars["String"]["input"];
};

export type QueryAddressDetailsArgs = {
  ref: Scalars["String"]["input"];
};

export type QueryBalanceArgs = {
  location: Scalars["String"]["input"];
};

export type QueryBillArgs = {
  billId?: InputMaybe<Scalars["String"]["input"]>;
  location: Scalars["String"]["input"];
  ref?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryBillPaymentConfigArgs = {
  location: Scalars["String"]["input"];
};

export type QueryCardsArgs = {
  location?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryCheckInArgs = {
  location?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryDiscountArgs = {
  location: Scalars["String"]["input"];
};

export type QueryDiscountsArgs = {
  adjustments?: InputMaybe<Array<OrderAdjustment>>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  deliveryAddress?: InputMaybe<DeliveryAddress>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  items?: InputMaybe<Array<OrderAheadItem>>;
  location: Scalars["String"]["input"];
  selectedTimeSlot?: InputMaybe<Scalars["String"]["input"]>;
  total: Scalars["Int"]["input"];
};

export type QueryEmbeddedUrlArgs = {
  appUrl: Scalars["String"]["input"];
};

export type QueryFeaturesArgs = {
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
  keys: Array<Scalars["String"]["input"]>;
};

export type QueryMessagesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryOrderArgs = {
  orderId: Scalars["String"]["input"];
};

export type QueryOrderingArgs = {
  location?: InputMaybe<Scalars["String"]["input"]>;
  locationRef?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPaymentArgs = {
  paymentId: Scalars["String"]["input"];
};

export type QueryProfileFieldsArgs = {
  scope: ProfileScope;
};

export type QueryPromotionsArgs = {
  locationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryRewardArgs = {
  id: Scalars["String"]["input"];
};

export type QueryRewardsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  locationRef?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySpendHistoryArgs = {
  dateFrom?: InputMaybe<Scalars["Date"]["input"]>;
  dateTo?: InputMaybe<Scalars["Date"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  transactionId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySpendOptionsArgs = {
  location?: InputMaybe<Scalars["String"]["input"]>;
  supportedActions?: InputMaybe<Array<SpendAction>>;
};

export type QueryWebLinksArgs = {
  locationRef?: InputMaybe<Scalars["String"]["input"]>;
};

/** Redeem code result extends a mutation result, but also provides message and title in the event of success */
export type RedeemCodeResult = MutationResult & {
  __typename?: "RedeemCodeResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful this will provide the details of the success message */
  messageDetails?: Maybe<MessageDetails>;
};

export type Reward = RewardCredit | RewardDiscount;

export type RewardCredit = {
  __typename?: "RewardCredit";
  amount: Scalars["Int"]["output"];
  expiresAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  locations?: Maybe<Array<Location>>;
  remaining: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
};

export type RewardDiscount = {
  __typename?: "RewardDiscount";
  allocations?: Maybe<Array<RewardDiscountAllocation>>;
  expiresAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
  items?: Maybe<Array<RewardItem>>;
  locations?: Maybe<Array<Location>>;
  maxAmount?: Maybe<Scalars["Int"]["output"]>;
  maxRedemptionsPerCustomer?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
  rate: Scalars["Float"]["output"];
  remainingRedemptionsPerCustomer?: Maybe<Scalars["Int"]["output"]>;
  startAt?: Maybe<Scalars["Date"]["output"]>;
};

export type RewardDiscountAllocation = {
  __typename?: "RewardDiscountAllocation";
  expiresAt?: Maybe<Scalars["Date"]["output"]>;
  id: Scalars["String"]["output"];
};

export type RewardItem = {
  __typename?: "RewardItem";
  id: Scalars["String"]["output"];
};

/** Extended information if the code provided a reward */
export type RewardMessageDetails = MessageDetails & {
  __typename?: "RewardMessageDetails";
  message: Scalars["String"]["output"];
  rewardType: PromotionRewardType;
  title: Scalars["String"]["output"];
};

/** Results for an activity query */
export type RewardResult = {
  __typename?: "RewardResult";
  /** The items for the query results */
  items: Array<Reward>;
  /** Pagination information */
  pageInfo?: Maybe<PageInfo>;
};

export enum ScannerBehaviour {
  /** Scanner will be available and displayed first/automatically */
  Auto = "AUTO",
  /** Scanner won't be available */
  Disabled = "DISABLED",
  /** Scanner will be available via a link below ref entry */
  Enabled = "ENABLED",
}

export type Session = {
  __typename?: "Session";
  appId?: Maybe<Scalars["String"]["output"]>;
  /** Deprecated. All features should be moved internal to Tidy API. */
  astonAccessToken?: Maybe<Scalars["String"]["output"]>;
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  deviceId?: Maybe<Scalars["String"]["output"]>;
  expiresAt?: Maybe<Scalars["Date"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  merchantId?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  userId?: Maybe<Scalars["String"]["output"]>;
  userRole?: Maybe<Scalars["String"]["output"]>;
  verified?: Maybe<Scalars["Date"]["output"]>;
};

export type SetupIntent = {
  __typename?: "SetupIntent";
  /** Secret for this setup intent, required for the Stripe mobile app and web SDKs */
  clientSecret: Scalars["String"]["output"];
};

export type SetupIntentResult = MutationResult & {
  __typename?: "SetupIntentResult";
  /** If unsuccessful this will be defined and indicates why the operation failed */
  error?: Maybe<MutationError>;
  /** If successful this will provide the details of the setup intent */
  intent?: Maybe<SetupIntent>;
};

export enum SpendAction {
  /** Connect payments */
  Connect = "CONNECT",
  /** Connect payments, then proceed to in store check in */
  ConnectInStore = "CONNECT_IN_STORE",
  /** Connect payments, then proceed to order ahead via web URL */
  ConnectOrderAhead = "CONNECT_ORDER_AHEAD",
  /** Connect payments, then proceed to order ahead via native UI */
  ConnectOrderAheadNative = "CONNECT_ORDER_AHEAD_NATIVE",
  /** Connect payments, then proceed to order at table via native UI */
  ConnectOrderAtTableNative = "CONNECT_ORDER_AT_TABLE_NATIVE",
  /** Connect payments, then proceed to pay at table */
  ConnectPayAtTable = "CONNECT_PAY_AT_TABLE",
  /** Check in to spend in store */
  InStore = "IN_STORE",
  /** Order ahead via a web URL */
  OrderAhead = "ORDER_AHEAD",
  /** Order ahead via the native UI */
  OrderAheadNative = "ORDER_AHEAD_NATIVE",
  /** Order at table via the native UI */
  OrderAtTableNative = "ORDER_AT_TABLE_NATIVE",
  /** Pay at table */
  PayAtTable = "PAY_AT_TABLE",
  /** View active transaction (in store check in) */
  ViewActive = "VIEW_ACTIVE",
}

export type SpendActivity = Activity & {
  __typename?: "SpendActivity";
  cart?: Maybe<Cart>;
  /** Unique ID */
  id: Scalars["String"]["output"];
  locationName: Scalars["String"]["output"];
  order: Order;
  points: Scalars["Int"]["output"];
  pointsText: Scalars["String"]["output"];
  timestamp: Scalars["Date"]["output"];
  title: Scalars["String"]["output"];
};

export type SpendHistoryItem = {
  __typename?: "SpendHistoryItem";
  /** Didn't think these were used but they are by a few old app versions. */
  amount?: Maybe<Scalars["String"]["output"]>;
  amountLabel: Scalars["String"]["output"];
  amountText: Scalars["String"]["output"];
  discount?: Maybe<Scalars["String"]["output"]>;
  discountText: Scalars["String"]["output"];
  id?: Maybe<Scalars["String"]["output"]>;
  items?: Maybe<Array<SpendHistoryItemLineItem>>;
  location: Scalars["String"]["output"];
  /** PaymentMethodName should not be null for new transactions, but for old ones it is null. eg. ••••1234 or john@example.com. */
  paymentMethodName?: Maybe<Scalars["String"]["output"]>;
  /** PaymentMethodType should not be null for new transactions, but for old ones it is null. eg. visa, mastercard, paypal. */
  paymentMethodType?: Maybe<Scalars["String"]["output"]>;
  points?: Maybe<Scalars["Int"]["output"]>;
  pointsLabel: Scalars["String"]["output"];
  pointsText: Scalars["String"]["output"];
  pointsTextDetail: Scalars["String"]["output"];
  subtotal?: Maybe<Scalars["String"]["output"]>;
  subtotalText: Scalars["String"]["output"];
  timestamp: Scalars["Date"]["output"];
};

export type SpendHistoryItemLineItem = {
  __typename?: "SpendHistoryItemLineItem";
  /** Didn't think these were used but they are by a few old app versions. */
  amount?: Maybe<Scalars["String"]["output"]>;
  amountText: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  points?: Maybe<Scalars["Int"]["output"]>;
  quantity?: Maybe<Scalars["Int"]["output"]>;
  quantityText: Scalars["String"]["output"];
};

/** A spend option is typically represented by a button on the card list screen. */
export type SpendOption = {
  __typename?: "SpendOption";
  /** The action defines what to do when the button is pressed. */
  action: SpendAction;
  /**
   * True if the SpendAction is IN_STORE and the merchant requires a limit to be specified, null if action is not IN_STORE.
   * @deprecated No UI/business logic regarding this
   */
  hasLimit?: Maybe<Scalars["Boolean"]["output"]>;
  /** Label for this button. */
  label: Scalars["String"]["output"];
  /** Some options may have a number (check in number, order number, etc) associated with them. Null otherwise. */
  number?: Maybe<Scalars["String"]["output"]>;
  /** Some actions may have a URL associated with them. Null for others. */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Standard response for a mutation */
export type StandardMutationResult = MutationResult & {
  __typename?: "StandardMutationResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
};

/** Contains an OrderSession just like CreateOrderResult */
export type StartPromotionRedemptionResult = MutationResult & {
  __typename?: "StartPromotionRedemptionResult";
  /** If unsuccessful this will be set and indicates why the mutation failed */
  error?: Maybe<MutationError>;
  /** If successful this will provide the details of the order session */
  session?: Maybe<OrderSession>;
};

export type StringKeyValue = KeyValue & {
  __typename?: "StringKeyValue";
  dataType: ValueType;
  key: Scalars["String"]["output"];
  strValue?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type Strings = {
  __typename?: "Strings";
  /** Currently defaults to 'Earn 10 points on every $1 spent'. */
  noPointsText?: Maybe<Scalars["String"]["output"]>;
  /** Service Charge content */
  serviceChargeApply: Scalars["String"]["output"];
  /** Service Charge content */
  serviceChargeBody: Scalars["String"]["output"];
  /** Service Charge content */
  serviceChargeRemove: Scalars["String"]["output"];
  /** Service Charge content */
  serviceChargeTitle: Scalars["String"]["output"];
  /** Retrieves Bill Payment language from office languages */
  webBillPaymentName?: Maybe<Scalars["String"]["output"]>;
  /** Retrieves Title for Location Selection landing page in web */
  webChooseLocationTitle?: Maybe<Scalars["String"]["output"]>;
  /** button label for paying externally for delivery (e.g. cash) */
  webExternalPaymentDeliveryButton: Scalars["String"]["output"];
  /** confirm message for when user selects external payment for delivery */
  webExternalPaymentDeliveryMessage: Scalars["String"]["output"];
  /** button label for paying externally for pickup (e.g. cash) */
  webExternalPaymentPickUpButton: Scalars["String"]["output"];
  /** confirm message for when user selects external payment for pickup */
  webExternalPaymentPickUpMessage: Scalars["String"]["output"];
  /** button label for paying externally for table service(e.g. cash) */
  webExternalPaymentServiceButton: Scalars["String"]["output"];
  /** confirm message for when user selects external payment for table service */
  webExternalPaymentServiceMessage: Scalars["String"]["output"];
  /** Retrieves Delivery string from office languages */
  webOrderDeliveryName?: Maybe<Scalars["String"]["output"]>;
  /** Retrieves Order Pick Up string from office languages */
  webOrderPickupName?: Maybe<Scalars["String"]["output"]>;
  /** Retrieves Order Table Service string from office languages */
  webOrderServiceName?: Maybe<Scalars["String"]["output"]>;
  /** Label for placeRef ie: "Room Number" */
  webPlaceRefLabel: Scalars["String"]["output"];
  /** Label for serviceRef ie: "Table Number" */
  webServiceRefLabel: Scalars["String"]["output"];
  /** Message displayed if serviceRef not found */
  webServiceRefNotFoundMessage: Scalars["String"]["output"];
};

/** Stripe Connect metadata */
export type StripeConnectMetadata = PaymentsMetadata & {
  __typename?: "StripeConnectMetadata";
  /** Display name for the gateway. Always Stripe Connect. */
  name: Scalars["String"]["output"];
  /** Stripe publishable key */
  publishableKey: Scalars["String"]["output"];
  /** Always STRIPE_CONNECT */
  type: PaymentsType;
};

/** Metadata specific to a STRIPE gateway. */
export type StripeMetadata = PaymentsMetadata & {
  __typename?: "StripeMetadata";
  /** Display name for the gateway. */
  name: Scalars["String"]["output"];
  /** Key needed for app to do tokenization. */
  publishableKey?: Maybe<Scalars["String"]["output"]>;
  /** Always STRIPE type. */
  type: PaymentsType;
};

/** SummaryItem */
export type SummaryItem = {
  __typename?: "SummaryItem";
  /** Amount of this summary item in lowest denomination (eg cents) */
  amount: Scalars["Int"]["output"];
  /** Label (sub-total, discount, credit, service charge) */
  label: Scalars["String"]["output"];
  /** Type Associated with the label (sub-total, discount, credit, service charge) */
  summaryItemType: SummaryItemType;
  /** Tax included in this summary item in lowest denomination */
  taxIncluded?: Maybe<Scalars["Int"]["output"]>;
};

/** Type of the Summary Items returned when creating an Order */
export enum SummaryItemType {
  /** The total credit applied to the order */
  Credit = "CREDIT",
  /** The cost amount of the customer platform fee (not applied to external payments) */
  CustomerFee = "CUSTOMER_FEE",
  /** The amount discounted from the order for an individual discount item */
  Discount = "DISCOUNT",
  /** The total cost of all the cart items in the order (including delivery) */
  ItemTotal = "ITEM_TOTAL",
  /** The difference of the ITEM_TOTAL and all the DISCOUNT items (not including credit) */
  Subtotal = "SUBTOTAL",
  /** The tip amount added to the order */
  Tip = "TIP",
}

/** Represents an unpaid bill assigned to a table. */
export type TableBill = {
  __typename?: "TableBill";
  /** The remaining to be paid on this bill (will be lower than total if existing payments have been made). Specified in lowest denomination of currency defined in `merchant.currency`. */
  balance: Scalars["Int"]["output"];
  /** Indicates whether the bill is closed and cannot accept further payments. */
  closed: Scalars["Boolean"]["output"];
  /** When the bill was created, nullable until bills v1 removed */
  createdAt?: Maybe<Scalars["Date"]["output"]>;
  /** Unique ID for this bill. */
  id: Scalars["String"]["output"];
  /** A list of items on this bill. These serve purely as metadata to allow the customer to identify the correct bill to be paid. */
  items: Array<TableBillItem>;
  /** A list of payment methods (eg: credit cards) available (will be empty list if user has not created a wallet). */
  payments?: Maybe<Array<TableBillPayment>>;
  /** Indicates whether this bill supports tip payments. If false then the tips UI should not be shown. */
  tipsAllowed: Scalars["Boolean"]["output"];
  /** The total to be paid on this bill. Specified in lowest denomination of currency defined in `merchant.currency. */
  total: Scalars["Int"]["output"];
  /** When the bill was last updated, nullable until bills v1 removed */
  updatedAt?: Maybe<Scalars["Date"]["output"]>;
};

/** Represents a single line item on a table bill. */
export type TableBillItem = {
  __typename?: "TableBillItem";
  /** The per-quantity amount of this bill item. May be 0. Specified in lowest denomination of currency defined in `merchant.currency`. */
  amount: Scalars["Int"]["output"];
  /** Descriptive name for this item. */
  name: Scalars["String"]["output"];
  /** The quantity of this item. Must be greater than 0. The total amount for this line is `amount*quantity`. */
  quantity: Scalars["Int"]["output"];
  /** subItems - an array containing items with name and amount */
  subItems?: Maybe<Array<TableBillSubItem>>;
  /** Line item type */
  type: TableBillItemType;
};

/** The line item type for table bill items */
export enum TableBillItemType {
  /** Item adjustment */
  Adjustment = "ADJUSTMENT",
  /** Item discount */
  Discount = "DISCOUNT",
  /** Item */
  Item = "ITEM",
}

/** Standard response for a mutation + a bill */
export type TableBillMutationResult = MutationResult & {
  __typename?: "TableBillMutationResult";
  /** If success, return updated bill. Will be null if there is an error. */
  bill?: Maybe<TableBill>;
  /** If unsuccessful this will be set and indicates why the mutation failed. Will be null if successful. */
  error?: Maybe<MutationError>;
};

/** Payment done by user. */
export type TableBillPayment = {
  __typename?: "TableBillPayment";
  /** Amount paid off balance, ie total - tip. */
  amount: Scalars["Int"]["output"];
  /** Order Id for reference. */
  id?: Maybe<Scalars["String"]["output"]>;
  /** Payment name. */
  name: Scalars["String"]["output"];
  /** Tip paid. */
  tip: Scalars["Int"]["output"];
  /** Total paid amount. */
  total: Scalars["Int"]["output"];
};

/** Represents a single line sub item on a table bill. */
export type TableBillSubItem = {
  __typename?: "TableBillSubItem";
  /** The per-quantity amount of this bill item. May be 0. Specified in lowest denomination of currency defined in `merchant.currency`. */
  amount: Scalars["Int"]["output"];
  /** Descriptive name for this item. */
  name: Scalars["String"]["output"];
};

export type TimeSlot = {
  __typename?: "TimeSlot";
  available: Scalars["Boolean"]["output"];
  endTime: Scalars["String"]["output"];
  ref: Scalars["String"]["output"];
  startTime: Scalars["String"]["output"];
};

export enum Tone {
  Completed = "COMPLETED",
  Failed = "FAILED",
  InProgress = "IN_PROGRESS",
}

export type Transaction = {
  __typename?: "Transaction";
  chargeTotal: Scalars["String"]["output"];
  completed?: Maybe<Scalars["Date"]["output"]>;
  created: Scalars["Date"]["output"];
  id: Scalars["String"]["output"];
  lineItems?: Maybe<Array<TransactionItem>>;
  state: Scalars["String"]["output"];
  updated?: Maybe<Scalars["Date"]["output"]>;
};

export type TransactionItem = {
  __typename?: "TransactionItem";
  amount: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export enum ValueType {
  Boolean = "BOOLEAN",
  Integer = "INTEGER",
  String = "STRING",
}

/** Wallet providers */
export enum Wallet {
  Androidpay = "ANDROIDPAY",
  Applepay = "APPLEPAY",
  Masterpass = "MASTERPASS",
}

/** TODO: Do we have a better name */
export type WebEmbeddedPaymentOption = PaymentOption & {
  __typename?: "WebEmbeddedPaymentOption";
  action: PaymentAction;
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type WebLink = {
  __typename?: "WebLink";
  href: Scalars["String"]["output"];
  text: Scalars["String"]["output"];
};

export type WebOrderingPaymentOption = PaymentOption & {
  __typename?: "WebOrderingPaymentOption";
  action: PaymentAction;
  id: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  /** TODO what should this actually be called */
  url: Scalars["String"]["output"];
};

export type WebPromotion = {
  __typename?: "WebPromotion";
  badgeText: Scalars["String"]["output"];
  claimButtonText?: Maybe<Scalars["String"]["output"]>;
  collectionDescription?: Maybe<Scalars["String"]["output"]>;
  details?: Maybe<Scalars["String"]["output"]>;
  displayOrder: Scalars["Int"]["output"];
  displayType?: Maybe<PromotionDisplayType>;
  id: Scalars["String"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  locations?: Maybe<Array<PromotionLocation>>;
  price?: Maybe<Scalars["Float"]["output"]>;
  priceType: PromotionPriceType;
  rewardType?: Maybe<PromotionRewardType>;
  title: Scalars["String"]["output"];
  type: PromotionType;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type GetActivityQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetActivityQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "ActivityResult";
    pageInfo: {
      __typename?: "PageInfo";
      hasPreviousPage: boolean;
      hasNextPage: boolean;
      startCursor: string;
      endCursor: string;
    };
    items: Array<
      | {
          __typename: "CreditExpiredActivity";
          id: string;
          title: string;
          timestamp: string;
          locationName?: string | null;
          credit: {
            __typename?: "Credit";
            id: string;
            title: string;
            amount: number;
            remaining: number;
            created: string;
            expires: string;
          };
        }
      | {
          __typename: "ItemExpiredActivity";
          id: string;
          title: string;
          timestamp: string;
          locationName?: string | null;
          item: {
            __typename?: "Item";
            id?: string | null;
            name?: string | null;
            expires?: string | null;
            claimed?: string | null;
            claimedLocation?: string | null;
            imageUrl?: string | null;
          };
        }
      | {
          __typename: "MessageActivity";
          body: string;
          id: string;
          title: string;
          timestamp: string;
          locationName?: string | null;
        }
      | {
          __typename: "PointsActivity";
          points: number;
          pointsText: string;
          id: string;
          title: string;
          timestamp: string;
          locationName?: string | null;
        }
      | {
          __typename: "PromotionActivity";
          points: number;
          pointsText: string;
          id: string;
          title: string;
          timestamp: string;
          locationName?: string | null;
          promotion: {
            __typename?: "Promotion";
            title: string;
            details: string;
            price?: number | null;
            priceType?: PromotionPriceType | null;
          };
          promotionItem?: {
            __typename?: "Item";
            name?: string | null;
            expires?: string | null;
            claimed?: string | null;
            claimedLocation?: string | null;
            imageUrl?: string | null;
          } | null;
          promotionOrder?: {
            __typename?: "Order";
            total: number;
            tax?: number | null;
            itemTotal: number;
            itemTax?: number | null;
            refId: string;
            id: string;
            billingType?: string | null;
            tipAmount?: number | null;
            creditAmount: number;
            customerFeeAmount: number;
            currency: string;
            serviceRef?: string | null;
            event: { __typename?: "PosEvent"; tone: Tone; message: string };
            deliveryAddress?: {
              __typename?: "AddressDelivery";
              apartment?: string | null;
              streetAddress: string;
              locality: string;
              region: string;
              country: string;
              postcode: string;
              coords: { __typename?: "Coords"; lat: number; lng: number };
            } | null;
            items: Array<{
              __typename?: "OrderItem";
              amount: number;
              tax?: number | null;
              name: string;
              quantity: number;
              options?: Array<{
                __typename?: "OrderOption";
                name: string;
                choices: Array<{
                  __typename?: "OrderChoice";
                  amount: number;
                  name: string;
                  tax?: number | null;
                } | null>;
              } | null> | null;
            }>;
            discounts?: Array<{
              __typename?: "OrderModifier";
              amount: number;
              tax?: number | null;
              name: string;
            } | null> | null;
          } | null;
          promotionCredit?: {
            __typename?: "Credit";
            id: string;
            title: string;
            amount: number;
            remaining: number;
            created: string;
            expires: string;
          } | null;
        }
      | {
          __typename: "SpendActivity";
          pointsText: string;
          points: number;
          id: string;
          title: string;
          timestamp: string;
          locationName: string;
          order: {
            __typename?: "Order";
            total: number;
            tax?: number | null;
            itemTotal: number;
            itemTax?: number | null;
            refId: string;
            id: string;
            billingType?: string | null;
            tipAmount?: number | null;
            creditAmount: number;
            customerFeeAmount: number;
            externalAmount: number;
            currency: string;
            paymentId?: string | null;
            paymentMethodType?: string | null;
            paymentMethodName?: string | null;
            paymentMethodIconUrl?: string | null;
            serviceRef?: string | null;
            fulfillAt?: string | null;
            estimatedReadyAt?: string | null;
            deliveryAtMin?: string | null;
            deliveryAtMax?: string | null;
            event: { __typename?: "PosEvent"; tone: Tone; message: string };
            deliveryAddress?: {
              __typename?: "AddressDelivery";
              apartment?: string | null;
              streetAddress: string;
              locality: string;
              region: string;
              country: string;
              postcode: string;
              coords: { __typename?: "Coords"; lat: number; lng: number };
            } | null;
            items: Array<{
              __typename?: "OrderItem";
              amount: number;
              tax?: number | null;
              name: string;
              quantity: number;
              options?: Array<{
                __typename?: "OrderOption";
                name: string;
                choices: Array<{
                  __typename?: "OrderChoice";
                  amount: number;
                  name: string;
                  tax?: number | null;
                } | null>;
              } | null> | null;
            }>;
            discounts?: Array<{
              __typename?: "OrderModifier";
              amount: number;
              tax?: number | null;
              name: string;
            } | null> | null;
          };
          cart?: {
            __typename?: "Cart";
            locationId: string;
            locationRef: string;
            timestamp: string;
            notes?: string | null;
            items: Array<{
              __typename?: "CartItem";
              id: string;
              note?: string | null;
              quantity: number;
              options: Array<{
                __typename?: "CartItemOption";
                id: string;
                choices: Array<{
                  __typename?: "CartItemChoice";
                  id: string;
                  quantity: number;
                  options: Array<{
                    __typename?: "CartItemOption";
                    id: string;
                    choices: Array<{
                      __typename?: "CartItemChoice";
                      id: string;
                      quantity: number;
                      options: Array<{
                        __typename?: "CartItemOption";
                        id: string;
                        choices: Array<{
                          __typename?: "CartItemChoice";
                          id: string;
                          quantity: number;
                        }>;
                      }>;
                    }>;
                  }>;
                }>;
              }>;
            }>;
          } | null;
        }
    >;
  };
};

export type GetActivitySummaryQueryVariables = Exact<{ [key: string]: never }>;

export type GetActivitySummaryQuery = {
  __typename?: "Query";
  activity: {
    __typename?: "ActivityResult";
    summary: {
      __typename?: "ActivitySummary";
      points: number;
      credit: number;
      itemCount: number;
    };
  };
  rewards?: {
    __typename?: "RewardResult";
    items: Array<
      | { __typename?: "RewardCredit" }
      | { __typename: "RewardDiscount"; id: string }
    >;
  } | null;
};

export type GetAddressesQueryVariables = Exact<{
  query: Scalars["String"]["input"];
  locationRef?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetAddressesQuery = {
  __typename?: "Query";
  addressAutocomplete: Array<{
    __typename?: "AddressAutocomplete";
    name: string;
    ref: string;
  }>;
};

export type GetAddressDetailsQueryVariables = Exact<{
  ref: Scalars["String"]["input"];
}>;

export type GetAddressDetailsQuery = {
  __typename?: "Query";
  addressDetails: {
    __typename?: "AddressDetailsResponse";
    details?: {
      __typename?: "AddressDetails";
      name: string;
      streetAddress: string;
      locality: string;
      postcode: string;
      region: string;
      country: string;
      coords: { __typename?: "Coords"; lat: number; lng: number };
    } | null;
    error?: { __typename?: "AddressDetailsError"; message: string } | null;
  };
};

export type RedeemCodeMutationVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type RedeemCodeMutation = {
  __typename?: "Mutation";
  redeemCode: {
    __typename?: "RedeemCodeResult";
    error?: { __typename?: "MutationError"; message: string } | null;
    messageDetails?:
      | { __typename?: "GenericMessageDetails"; title: string; message: string }
      | {
          __typename?: "RewardMessageDetails";
          rewardType: PromotionRewardType;
          title: string;
          message: string;
        }
      | null;
  };
};

export type GetCreditDiscountQueryVariables = Exact<{
  location: Scalars["String"]["input"];
  orderTotal: Scalars["Int"]["input"];
  orderItems?: InputMaybe<Array<OrderAheadItem> | OrderAheadItem>;
  adjustments?: InputMaybe<Array<OrderAdjustment> | OrderAdjustment>;
  fulfillmentType?: InputMaybe<FulfillmentType>;
  selectedTimeSlot?: InputMaybe<Scalars["String"]["input"]>;
  currency?: InputMaybe<Scalars["String"]["input"]>;
  deliveryAddress?: InputMaybe<DeliveryAddress>;
}>;

export type GetCreditDiscountQuery = {
  __typename?: "Query";
  balance: { __typename?: "Balance"; credit?: number | null };
  discounts?: Array<{
    __typename?: "Discount";
    id: string;
    name: string;
    discountAmount: number;
    discountTax?: number | null;
    itemId?: string | null;
  }> | null;
};

export type GetFeaturesQueryVariables = Exact<{
  keys: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
  deviceId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetFeaturesQuery = {
  __typename?: "Query";
  features: Array<{
    __typename?: "FeatureFlag";
    key: string;
    enabled: boolean;
  }>;
};

export type GetLanguageStringsQueryVariables = Exact<{ [key: string]: never }>;

export type GetLanguageStringsQuery = {
  __typename?: "Query";
  strings?: {
    __typename?: "Strings";
    webOrderPickupName?: string | null;
    webOrderDeliveryName?: string | null;
    webOrderServiceName?: string | null;
    webChooseLocationTitle?: string | null;
    serviceChargeTitle: string;
    serviceChargeBody: string;
    serviceChargeApply: string;
    serviceChargeRemove: string;
    webServiceRefLabel: string;
    webPlaceRefLabel: string;
    webExternalPaymentPickUpButton: string;
    webExternalPaymentPickUpMessage: string;
    webExternalPaymentDeliveryButton: string;
    webExternalPaymentDeliveryMessage: string;
    webExternalPaymentServiceButton: string;
    webExternalPaymentServiceMessage: string;
  } | null;
};

export type GetLocationQueryVariables = Exact<{
  locationRef: Scalars["String"]["input"];
}>;

export type GetLocationQuery = {
  __typename?: "Query";
  merchant: {
    __typename?: "Merchant";
    name: string;
    location?: {
      __typename?: "Location";
      id: string;
      uid: string;
      slug?: string | null;
      name: string;
      phoneNumber?: string | null;
      openingHours?: string | null;
      website?: string | null;
      orderAheadEnabled: boolean;
      orderAtTableEnabled: boolean;
      orderDeliveryEnabled: boolean;
      timezone: string;
      address?: {
        __typename?: "Address";
        street?: string | null;
        locality?: string | null;
        region?: string | null;
        postalCode?: string | null;
        country?: string | null;
      } | null;
      coords?: {
        __typename?: "Coords";
        latitude: number;
        longitude: number;
      } | null;
      social?: {
        __typename?: "LocationSocialLinks";
        facebook?: string | null;
        twitter?: string | null;
        instagram?: string | null;
      } | null;
    } | null;
  };
};

export type GetLocationsQueryVariables = Exact<{
  nativeOrderingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  currentCoords?: InputMaybe<CoordsInput>;
}>;

export type GetLocationsQuery = {
  __typename?: "Query";
  merchant: {
    __typename?: "Merchant";
    name: string;
    locations?: Array<{
      __typename?: "Location";
      id: string;
      uid: string;
      slug?: string | null;
      name: string;
      phoneNumber?: string | null;
      openingHours?: string | null;
      website?: string | null;
      orderAheadEnabled: boolean;
      orderAtTableEnabled: boolean;
      orderDeliveryEnabled: boolean;
      timezone: string;
      address?: {
        __typename?: "Address";
        street?: string | null;
        locality?: string | null;
        region?: string | null;
        postalCode?: string | null;
        country?: string | null;
      } | null;
      coords?: {
        __typename?: "Coords";
        latitude: number;
        longitude: number;
      } | null;
      social?: {
        __typename?: "LocationSocialLinks";
        facebook?: string | null;
        twitter?: string | null;
        instagram?: string | null;
      } | null;
    }> | null;
  };
};

export type GetLoginConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetLoginConfigQuery = {
  __typename?: "Query";
  merchant: {
    __typename?: "Merchant";
    googleClientId?: string | null;
    appleWebClientId?: string | null;
    settings: {
      __typename?: "MerchantSettings";
      loginProviders: Array<LoginProvider>;
    };
  };
};

export type GetMerchantQueryVariables = Exact<{ [key: string]: never }>;

export type GetMerchantQuery = {
  __typename?: "Query";
  merchant: {
    __typename?: "Merchant";
    uid: string;
    androidStoreUrl?: string | null;
    iosStoreUrl?: string | null;
    currency: string;
    settings: {
      __typename?: "MerchantSettings";
      termsAndConditionsURL: string;
    };
  };
};

export type GetMerchantRequiresPhoneQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMerchantRequiresPhoneQuery = {
  __typename?: "Query";
  merchant: {
    __typename?: "Merchant";
    settings: { __typename?: "MerchantSettings"; requirePhoneWeb: boolean };
  };
};

export type CreateOrderMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  locationRef: Scalars["String"]["input"];
  total: Scalars["Int"]["input"];
  items: Array<OrderAheadItem> | OrderAheadItem;
  notes?: InputMaybe<Scalars["String"]["input"]>;
  deliveryAddress?: InputMaybe<DeliveryAddress>;
  serviceRef?: InputMaybe<Scalars["String"]["input"]>;
  tip?: InputMaybe<Scalars["Int"]["input"]>;
  timeSlot?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateOrderMutation = {
  __typename?: "Mutation";
  createOrder: {
    __typename?: "CreateOrderResult";
    session?: {
      __typename?: "OrderSession";
      id: string;
      currency: string;
      paymentIntentSecret?: string | null;
      creditAmount: number;
      discountAmount: number;
      paymentAmount: number;
      requirePhoneVerification?: boolean | null;
      summaryItems: Array<{
        __typename?: "SummaryItem";
        label: string;
        summaryItemType: SummaryItemType;
        amount: number;
        taxIncluded?: number | null;
      }>;
    } | null;
    error?: { __typename?: "MutationError"; message: string } | null;
  };
};

export type UpdateOrderTipMutationVariables = Exact<{
  orderId: Scalars["String"]["input"];
  tip: Scalars["Int"]["input"];
}>;

export type UpdateOrderTipMutation = {
  __typename?: "Mutation";
  updateOrderTip: {
    __typename?: "StandardMutationResult";
    error?: { __typename?: "MutationError"; message: string } | null;
  };
};

export type CompleteOrderMutationVariables = Exact<{
  orderId: Scalars["String"]["input"];
  externalPayment?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CompleteOrderMutation = {
  __typename?: "Mutation";
  completeOrder: {
    __typename?: "StandardMutationResult";
    error?: { __typename?: "MutationError"; message: string } | null;
  };
};

export type CancelOrderMutationVariables = Exact<{
  orderId: Scalars["String"]["input"];
}>;

export type CancelOrderMutation = {
  __typename?: "Mutation";
  cancelOrder: {
    __typename?: "StandardMutationResult";
    error?: { __typename?: "MutationError"; message: string } | null;
  };
};

export type BaseProductFieldsFragment = {
  __typename?: "ProductV2";
  id: string;
  plu?: string | null;
  title: string;
  description?: string | null;
  imageUrl?: string | null;
  available: boolean;
  tags: Array<string>;
  visibility?: Array<{
    __typename?: "Period";
    start: string;
    end: string;
    dayOfTheWeek: DayOfTheWeek;
  }> | null;
  price: { __typename?: "Price"; amount: number; taxIncluded?: number | null };
};

export type DeepProductFieldsFragment = {
  __typename?: "ProductV2";
  id: string;
  plu?: string | null;
  title: string;
  description?: string | null;
  imageUrl?: string | null;
  available: boolean;
  tags: Array<string>;
  options: Array<{
    __typename?: "ProductOptionV2";
    id: string;
    title: string;
    minQuantity: number;
    maxQuantity?: number | null;
    choices: Array<{
      __typename?: "OptionChoiceV2";
      minQuantity: number;
      maxQuantity: number;
      defaultQuantity: number;
      product: {
        __typename?: "ProductV2";
        id: string;
        plu?: string | null;
        title: string;
        description?: string | null;
        imageUrl?: string | null;
        available: boolean;
        tags: Array<string>;
        options: Array<{
          __typename?: "ProductOptionV2";
          id: string;
          title: string;
          minQuantity: number;
          maxQuantity?: number | null;
          choices: Array<{
            __typename?: "OptionChoiceV2";
            minQuantity: number;
            maxQuantity: number;
            defaultQuantity: number;
            product: {
              __typename?: "ProductV2";
              id: string;
              plu?: string | null;
              title: string;
              description?: string | null;
              imageUrl?: string | null;
              available: boolean;
              tags: Array<string>;
              options: Array<{
                __typename?: "ProductOptionV2";
                id: string;
                title: string;
                minQuantity: number;
                maxQuantity?: number | null;
                choices: Array<{
                  __typename?: "OptionChoiceV2";
                  minQuantity: number;
                  maxQuantity: number;
                  defaultQuantity: number;
                  product: {
                    __typename?: "ProductV2";
                    id: string;
                    plu?: string | null;
                    title: string;
                    description?: string | null;
                    imageUrl?: string | null;
                    available: boolean;
                    tags: Array<string>;
                    options: Array<{
                      __typename?: "ProductOptionV2";
                      id: string;
                      title: string;
                      minQuantity: number;
                      maxQuantity?: number | null;
                      choices: Array<{
                        __typename?: "OptionChoiceV2";
                        minQuantity: number;
                        maxQuantity: number;
                        defaultQuantity: number;
                        product: {
                          __typename?: "ProductV2";
                          id: string;
                          plu?: string | null;
                          title: string;
                          description?: string | null;
                          imageUrl?: string | null;
                          available: boolean;
                          tags: Array<string>;
                          options: Array<{
                            __typename?: "ProductOptionV2";
                            id: string;
                            title: string;
                            minQuantity: number;
                            maxQuantity?: number | null;
                            choices: Array<{
                              __typename?: "OptionChoiceV2";
                              minQuantity: number;
                              maxQuantity: number;
                              defaultQuantity: number;
                              product: {
                                __typename?: "ProductV2";
                                id: string;
                                plu?: string | null;
                                title: string;
                                description?: string | null;
                                imageUrl?: string | null;
                                available: boolean;
                                tags: Array<string>;
                                visibility?: Array<{
                                  __typename?: "Period";
                                  start: string;
                                  end: string;
                                  dayOfTheWeek: DayOfTheWeek;
                                }> | null;
                                price: {
                                  __typename?: "Price";
                                  amount: number;
                                  taxIncluded?: number | null;
                                };
                              };
                            }>;
                          }>;
                          visibility?: Array<{
                            __typename?: "Period";
                            start: string;
                            end: string;
                            dayOfTheWeek: DayOfTheWeek;
                          }> | null;
                          price: {
                            __typename?: "Price";
                            amount: number;
                            taxIncluded?: number | null;
                          };
                        };
                      }>;
                    }>;
                    visibility?: Array<{
                      __typename?: "Period";
                      start: string;
                      end: string;
                      dayOfTheWeek: DayOfTheWeek;
                    }> | null;
                    price: {
                      __typename?: "Price";
                      amount: number;
                      taxIncluded?: number | null;
                    };
                  };
                }>;
              }>;
              visibility?: Array<{
                __typename?: "Period";
                start: string;
                end: string;
                dayOfTheWeek: DayOfTheWeek;
              }> | null;
              price: {
                __typename?: "Price";
                amount: number;
                taxIncluded?: number | null;
              };
            };
          }>;
        }>;
        visibility?: Array<{
          __typename?: "Period";
          start: string;
          end: string;
          dayOfTheWeek: DayOfTheWeek;
        }> | null;
        price: {
          __typename?: "Price";
          amount: number;
          taxIncluded?: number | null;
        };
      };
    }>;
  }>;
  visibility?: Array<{
    __typename?: "Period";
    start: string;
    end: string;
    dayOfTheWeek: DayOfTheWeek;
  }> | null;
  price: { __typename?: "Price"; amount: number; taxIncluded?: number | null };
};

export type GetProductQueryVariables = Exact<{
  location: Scalars["String"]["input"];
  productId: Scalars["String"]["input"];
}>;

export type GetProductQuery = {
  __typename?: "Query";
  ordering?: {
    __typename?: "Ordering";
    product?: {
      __typename?: "ProductV2";
      id: string;
      plu?: string | null;
      title: string;
      description?: string | null;
      imageUrl?: string | null;
      available: boolean;
      tags: Array<string>;
      options: Array<{
        __typename?: "ProductOptionV2";
        id: string;
        title: string;
        minQuantity: number;
        maxQuantity?: number | null;
        choices: Array<{
          __typename?: "OptionChoiceV2";
          minQuantity: number;
          maxQuantity: number;
          defaultQuantity: number;
          product: {
            __typename?: "ProductV2";
            id: string;
            plu?: string | null;
            title: string;
            description?: string | null;
            imageUrl?: string | null;
            available: boolean;
            tags: Array<string>;
            options: Array<{
              __typename?: "ProductOptionV2";
              id: string;
              title: string;
              minQuantity: number;
              maxQuantity?: number | null;
              choices: Array<{
                __typename?: "OptionChoiceV2";
                minQuantity: number;
                maxQuantity: number;
                defaultQuantity: number;
                product: {
                  __typename?: "ProductV2";
                  id: string;
                  plu?: string | null;
                  title: string;
                  description?: string | null;
                  imageUrl?: string | null;
                  available: boolean;
                  tags: Array<string>;
                  options: Array<{
                    __typename?: "ProductOptionV2";
                    id: string;
                    title: string;
                    minQuantity: number;
                    maxQuantity?: number | null;
                    choices: Array<{
                      __typename?: "OptionChoiceV2";
                      minQuantity: number;
                      maxQuantity: number;
                      defaultQuantity: number;
                      product: {
                        __typename?: "ProductV2";
                        id: string;
                        plu?: string | null;
                        title: string;
                        description?: string | null;
                        imageUrl?: string | null;
                        available: boolean;
                        tags: Array<string>;
                        options: Array<{
                          __typename?: "ProductOptionV2";
                          id: string;
                          title: string;
                          minQuantity: number;
                          maxQuantity?: number | null;
                          choices: Array<{
                            __typename?: "OptionChoiceV2";
                            minQuantity: number;
                            maxQuantity: number;
                            defaultQuantity: number;
                            product: {
                              __typename?: "ProductV2";
                              id: string;
                              plu?: string | null;
                              title: string;
                              description?: string | null;
                              imageUrl?: string | null;
                              available: boolean;
                              tags: Array<string>;
                              options: Array<{
                                __typename?: "ProductOptionV2";
                                id: string;
                                title: string;
                                minQuantity: number;
                                maxQuantity?: number | null;
                                choices: Array<{
                                  __typename?: "OptionChoiceV2";
                                  minQuantity: number;
                                  maxQuantity: number;
                                  defaultQuantity: number;
                                  product: {
                                    __typename?: "ProductV2";
                                    id: string;
                                    plu?: string | null;
                                    title: string;
                                    description?: string | null;
                                    imageUrl?: string | null;
                                    available: boolean;
                                    tags: Array<string>;
                                    visibility?: Array<{
                                      __typename?: "Period";
                                      start: string;
                                      end: string;
                                      dayOfTheWeek: DayOfTheWeek;
                                    }> | null;
                                    price: {
                                      __typename?: "Price";
                                      amount: number;
                                      taxIncluded?: number | null;
                                    };
                                  };
                                }>;
                              }>;
                              visibility?: Array<{
                                __typename?: "Period";
                                start: string;
                                end: string;
                                dayOfTheWeek: DayOfTheWeek;
                              }> | null;
                              price: {
                                __typename?: "Price";
                                amount: number;
                                taxIncluded?: number | null;
                              };
                            };
                          }>;
                        }>;
                        visibility?: Array<{
                          __typename?: "Period";
                          start: string;
                          end: string;
                          dayOfTheWeek: DayOfTheWeek;
                        }> | null;
                        price: {
                          __typename?: "Price";
                          amount: number;
                          taxIncluded?: number | null;
                        };
                      };
                    }>;
                  }>;
                  visibility?: Array<{
                    __typename?: "Period";
                    start: string;
                    end: string;
                    dayOfTheWeek: DayOfTheWeek;
                  }> | null;
                  price: {
                    __typename?: "Price";
                    amount: number;
                    taxIncluded?: number | null;
                  };
                };
              }>;
            }>;
            visibility?: Array<{
              __typename?: "Period";
              start: string;
              end: string;
              dayOfTheWeek: DayOfTheWeek;
            }> | null;
            price: {
              __typename?: "Price";
              amount: number;
              taxIncluded?: number | null;
            };
          };
        }>;
      }>;
      visibility?: Array<{
        __typename?: "Period";
        start: string;
        end: string;
        dayOfTheWeek: DayOfTheWeek;
      }> | null;
      price: {
        __typename?: "Price";
        amount: number;
        taxIncluded?: number | null;
      };
    } | null;
  } | null;
};

export type GetMenusQueryVariables = Exact<{
  location: Scalars["String"]["input"];
  dispatchOption?: InputMaybe<FulfillmentType>;
  productIds?: InputMaybe<
    Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  >;
}>;

export type GetMenusQuery = {
  __typename?: "Query";
  ordering?: {
    __typename?: "Ordering";
    menus?: Array<{
      __typename?: "MenuV2";
      id: string;
      title: string;
      fulfillmentType?: Array<FulfillmentType> | null;
      categories?: Array<{
        __typename?: "ProductCategoryV2";
        id: string;
        title: string;
        products?: Array<{
          __typename?: "ProductV2";
          id: string;
          plu?: string | null;
          title: string;
          description?: string | null;
          imageUrl?: string | null;
          available: boolean;
          tags: Array<string>;
          options: Array<{
            __typename?: "ProductOptionV2";
            id: string;
            title: string;
            minQuantity: number;
            maxQuantity?: number | null;
            choices: Array<{
              __typename?: "OptionChoiceV2";
              minQuantity: number;
              maxQuantity: number;
              defaultQuantity: number;
              product: {
                __typename?: "ProductV2";
                id: string;
                plu?: string | null;
                title: string;
                description?: string | null;
                imageUrl?: string | null;
                available: boolean;
                tags: Array<string>;
                options: Array<{
                  __typename?: "ProductOptionV2";
                  id: string;
                  title: string;
                  minQuantity: number;
                  maxQuantity?: number | null;
                  choices: Array<{
                    __typename?: "OptionChoiceV2";
                    minQuantity: number;
                    maxQuantity: number;
                    defaultQuantity: number;
                    product: {
                      __typename?: "ProductV2";
                      id: string;
                      plu?: string | null;
                      title: string;
                      description?: string | null;
                      imageUrl?: string | null;
                      available: boolean;
                      tags: Array<string>;
                      options: Array<{
                        __typename?: "ProductOptionV2";
                        id: string;
                        title: string;
                        minQuantity: number;
                        maxQuantity?: number | null;
                        choices: Array<{
                          __typename?: "OptionChoiceV2";
                          minQuantity: number;
                          maxQuantity: number;
                          defaultQuantity: number;
                          product: {
                            __typename?: "ProductV2";
                            id: string;
                            plu?: string | null;
                            title: string;
                            description?: string | null;
                            imageUrl?: string | null;
                            available: boolean;
                            tags: Array<string>;
                            options: Array<{
                              __typename?: "ProductOptionV2";
                              id: string;
                              title: string;
                              minQuantity: number;
                              maxQuantity?: number | null;
                              choices: Array<{
                                __typename?: "OptionChoiceV2";
                                minQuantity: number;
                                maxQuantity: number;
                                defaultQuantity: number;
                                product: {
                                  __typename?: "ProductV2";
                                  id: string;
                                  plu?: string | null;
                                  title: string;
                                  description?: string | null;
                                  imageUrl?: string | null;
                                  available: boolean;
                                  tags: Array<string>;
                                  options: Array<{
                                    __typename?: "ProductOptionV2";
                                    id: string;
                                    title: string;
                                    minQuantity: number;
                                    maxQuantity?: number | null;
                                    choices: Array<{
                                      __typename?: "OptionChoiceV2";
                                      minQuantity: number;
                                      maxQuantity: number;
                                      defaultQuantity: number;
                                      product: {
                                        __typename?: "ProductV2";
                                        id: string;
                                        plu?: string | null;
                                        title: string;
                                        description?: string | null;
                                        imageUrl?: string | null;
                                        available: boolean;
                                        tags: Array<string>;
                                        visibility?: Array<{
                                          __typename?: "Period";
                                          start: string;
                                          end: string;
                                          dayOfTheWeek: DayOfTheWeek;
                                        }> | null;
                                        price: {
                                          __typename?: "Price";
                                          amount: number;
                                          taxIncluded?: number | null;
                                        };
                                      };
                                    }>;
                                  }>;
                                  visibility?: Array<{
                                    __typename?: "Period";
                                    start: string;
                                    end: string;
                                    dayOfTheWeek: DayOfTheWeek;
                                  }> | null;
                                  price: {
                                    __typename?: "Price";
                                    amount: number;
                                    taxIncluded?: number | null;
                                  };
                                };
                              }>;
                            }>;
                            visibility?: Array<{
                              __typename?: "Period";
                              start: string;
                              end: string;
                              dayOfTheWeek: DayOfTheWeek;
                            }> | null;
                            price: {
                              __typename?: "Price";
                              amount: number;
                              taxIncluded?: number | null;
                            };
                          };
                        }>;
                      }>;
                      visibility?: Array<{
                        __typename?: "Period";
                        start: string;
                        end: string;
                        dayOfTheWeek: DayOfTheWeek;
                      }> | null;
                      price: {
                        __typename?: "Price";
                        amount: number;
                        taxIncluded?: number | null;
                      };
                    };
                  }>;
                }>;
                visibility?: Array<{
                  __typename?: "Period";
                  start: string;
                  end: string;
                  dayOfTheWeek: DayOfTheWeek;
                }> | null;
                price: {
                  __typename?: "Price";
                  amount: number;
                  taxIncluded?: number | null;
                };
              };
            }>;
          }>;
          visibility?: Array<{
            __typename?: "Period";
            start: string;
            end: string;
            dayOfTheWeek: DayOfTheWeek;
          }> | null;
          price: {
            __typename?: "Price";
            amount: number;
            taxIncluded?: number | null;
          };
        }> | null;
      }> | null;
      serviceAvailability?: Array<{
        __typename?: "Period";
        dayOfTheWeek: DayOfTheWeek;
        start: string;
        end: string;
      }> | null;
    }> | null;
  } | null;
};

export type GetBaseMenusQueryVariables = Exact<{
  location: Scalars["String"]["input"];
  dispatchOption?: InputMaybe<FulfillmentType>;
}>;

export type GetBaseMenusQuery = {
  __typename?: "Query";
  ordering?: {
    __typename?: "Ordering";
    menus?: Array<{
      __typename?: "MenuV2";
      id: string;
      title: string;
      fulfillmentType?: Array<FulfillmentType> | null;
      categories?: Array<{
        __typename?: "ProductCategoryV2";
        id: string;
        title: string;
        products?: Array<{
          __typename?: "ProductV2";
          id: string;
          plu?: string | null;
          title: string;
          description?: string | null;
          imageUrl?: string | null;
          available: boolean;
          tags: Array<string>;
          visibility?: Array<{
            __typename?: "Period";
            start: string;
            end: string;
            dayOfTheWeek: DayOfTheWeek;
          }> | null;
          price: {
            __typename?: "Price";
            amount: number;
            taxIncluded?: number | null;
          };
        }> | null;
      }> | null;
      serviceAvailability?: Array<{
        __typename?: "Period";
        dayOfTheWeek: DayOfTheWeek;
        start: string;
        end: string;
      }> | null;
    }> | null;
  } | null;
};

export type GetOrderingQueryVariables = Exact<{
  location: Scalars["String"]["input"];
  to?: InputMaybe<CoordsInput>;
}>;

export type GetOrderingQuery = {
  __typename?: "Query";
  ordering?: {
    __typename?: "Ordering";
    deliveryConfig?: {
      __typename?: "OrderDeliveryConfig";
      active: boolean;
      minimumAmount: number;
      feeAmount: number;
      minutesMin: number;
      minutesMax: number;
      allowItemNotes: boolean;
      allowOrderNotes: boolean;
      orderNotesMaxLength?: number | null;
      itemNotesMaxLength?: number | null;
      tipsEnabled: boolean;
      tipRatios: Array<number>;
      tipDefaultIndex?: number | null;
      externalPaymentEnabled?: boolean | null;
      feePrice?: {
        __typename?: "Price";
        amount: number;
        taxIncluded?: number | null;
      } | null;
      timeSlots?: Array<{
        __typename?: "TimeSlot";
        startTime: string;
        endTime: string;
        available: boolean;
        ref: string;
      }> | null;
    } | null;
    pickupConfig?: {
      __typename?: "OrderPickupConfig";
      active: boolean;
      waitTime: number;
      allowItemNotes: boolean;
      allowOrderNotes: boolean;
      orderNotesMaxLength?: number | null;
      itemNotesMaxLength?: number | null;
      tipsEnabled: boolean;
      tipRatios: Array<number>;
      tipDefaultIndex?: number | null;
      externalPaymentEnabled?: boolean | null;
      timeSlots?: Array<{
        __typename?: "TimeSlot";
        startTime: string;
        endTime: string;
        available: boolean;
        ref: string;
      }> | null;
    } | null;
    serviceConfig?: {
      __typename?: "OrderServiceConfig";
      waitTime: number;
      active: boolean;
      serviceChargeLabel?: string | null;
      serviceChargeRate?: number | null;
      allowItemNotes: boolean;
      allowOrderNotes: boolean;
      orderNotesMaxLength?: number | null;
      itemNotesMaxLength?: number | null;
      tipsEnabled: boolean;
      tipRatios: Array<number>;
      tipDefaultIndex?: number | null;
      externalPaymentEnabled?: boolean | null;
      validRefs?: Array<{ __typename?: "OrderServiceRef"; ref: string }> | null;
    } | null;
  } | null;
};

export type CheckDeliveryAddressQueryVariables = Exact<{
  location: Scalars["String"]["input"];
  address: DeliveryAddress;
}>;

export type CheckDeliveryAddressQuery = {
  __typename?: "Query";
  ordering?: {
    __typename?: "Ordering";
    deliveryAddressStatus?: {
      __typename?: "DeliveryAddressStatus";
      valid: boolean;
      messages: Array<string>;
    } | null;
  } | null;
};

export type GetRecentCartsQueryVariables = Exact<{
  location: Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
}>;

export type GetRecentCartsQuery = {
  __typename?: "Query";
  ordering?: {
    __typename?: "Ordering";
    recentCarts: Array<{
      __typename?: "Cart";
      locationRef: string;
      locationId: string;
      fulfillmentType?: FulfillmentType | null;
      notes?: string | null;
      timestamp: string;
      items: Array<{
        __typename?: "CartItem";
        id: string;
        quantity: number;
        note?: string | null;
        options: Array<{
          __typename?: "CartItemOption";
          id: string;
          choices: Array<{
            __typename?: "CartItemChoice";
            id: string;
            quantity: number;
            options: Array<{
              __typename?: "CartItemOption";
              id: string;
              choices: Array<{
                __typename?: "CartItemChoice";
                id: string;
                quantity: number;
                options: Array<{
                  __typename?: "CartItemOption";
                  id: string;
                  choices: Array<{
                    __typename?: "CartItemChoice";
                    id: string;
                    quantity: number;
                  }>;
                }>;
              }>;
            }>;
          }>;
        }>;
      }>;
    }>;
  } | null;
};

export type GetPayRequirementsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPayRequirementsQuery = {
  __typename?: "Query";
  merchant: {
    __typename?: "Merchant";
    settings: { __typename?: "MerchantSettings"; requirePhoneWeb: boolean };
  };
  me?: {
    __typename?: "Customer";
    firstName: string;
    lastName: string;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    dob?: string | null;
    hasAgreedToTerms: boolean;
    hasVerifiedPayments: boolean;
  } | null;
};

export type GetPaymentMethodsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPaymentMethodsQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "Customer";
    paymentMethods: Array<{
      __typename?: "PaymentMethod";
      id: string;
      typeText: string;
      idText: string;
      displayText: string;
      iconUrl: string;
    }>;
  } | null;
};

export type RemovePaymentMethodMutationVariables = Exact<{
  paymentMethod: Scalars["String"]["input"];
}>;

export type RemovePaymentMethodMutation = {
  __typename?: "Mutation";
  removePaymentMethodV2: {
    __typename?: "StandardMutationResult";
    error?: { __typename?: "MutationError"; message: string } | null;
  };
};

export type GetPaymentQueryVariables = Exact<{
  paymentId: Scalars["String"]["input"];
}>;

export type GetPaymentQuery = {
  __typename?: "Query";
  payment?: {
    __typename?: "Payment";
    state: PaymentState;
    session?: {
      __typename?: "OrderSession";
      id: string;
      paymentIntentSecret?: string | null;
      currency: string;
      creditAmount: number;
      discountAmount: number;
      paymentAmount: number;
      requirePhoneVerification?: boolean | null;
      tipAmount: number;
      summaryItems: Array<{
        __typename?: "SummaryItem";
        label: string;
        summaryItemType: SummaryItemType;
        amount: number;
        taxIncluded?: number | null;
      }>;
    } | null;
  } | null;
};

export type GetTransactionQueryVariables = Exact<{
  paymentId: Scalars["String"]["input"];
}>;

export type GetTransactionQuery = {
  __typename?: "Query";
  order?: {
    __typename?: "Order";
    points?: number | null;
    created: string;
    fulfillAt?: string | null;
    estimatedReadyAt?: string | null;
    deliveryAtMin?: string | null;
    deliveryAtMax?: string | null;
    total: number;
    tax?: number | null;
    itemTotal: number;
    itemTax?: number | null;
    billingType?: string | null;
    tipAmount?: number | null;
    creditAmount: number;
    customerFeeAmount: number;
    externalAmount: number;
    currency: string;
    paymentMethodType?: string | null;
    paymentMethodName?: string | null;
    paymentMethodIconUrl?: string | null;
    serviceRef?: string | null;
    orderAcceptedAt?: string | null;
    location?: {
      __typename?: "Location";
      id: string;
      slug?: string | null;
      name: string;
    } | null;
    event: {
      __typename?: "PosEvent";
      tone: Tone;
      message: string;
      timestamp: string;
    };
    items: Array<{
      __typename?: "OrderItem";
      amount: number;
      tax?: number | null;
      name: string;
      quantity: number;
      options?: Array<{
        __typename?: "OrderOption";
        name: string;
        choices: Array<{
          __typename?: "OrderChoice";
          amount: number;
          name: string;
          tax?: number | null;
        } | null>;
      } | null> | null;
    }>;
    discounts?: Array<{
      __typename?: "OrderModifier";
      amount: number;
      tax?: number | null;
      name: string;
    } | null> | null;
  } | null;
};

export type RequestPhoneVerificationMutationVariables = Exact<{
  phoneNumber: Scalars["String"]["input"];
}>;

export type RequestPhoneVerificationMutation = {
  __typename?: "Mutation";
  requestPhoneNumberVerification: {
    __typename?: "StandardMutationResult";
    error?: { __typename?: "MutationError"; message: string } | null;
  };
};

export type VerifyPhoneMutationVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type VerifyPhoneMutation = {
  __typename?: "Mutation";
  verifyPhoneNumber: {
    __typename?: "StandardMutationResult";
    error?: {
      __typename?: "MutationError";
      message: string;
      code?: string | null;
    } | null;
  };
};

export type GetUserProfileFieldsQueryVariables = Exact<{
  scope: ProfileScope;
}>;

export type GetUserProfileFieldsQuery = {
  __typename?: "Query";
  profileFields?: Array<{
    __typename?: "ProfileItem";
    label?: string | null;
    formattedLabel?: string | null;
    field?: string | null;
    value?: string | null;
    type?: ProfileItemType | null;
    required?: boolean | null;
  }> | null;
};

export type GetPromotionsHeaderQueryVariables = Exact<{
  locationRef: Scalars["String"]["input"];
}>;

export type GetPromotionsHeaderQuery = {
  __typename?: "Query";
  strings?: { __typename?: "Strings"; noPointsText?: string | null } | null;
  balance: {
    __typename?: "Balance";
    pointsText?: string | null;
    creditText?: string | null;
    credit?: number | null;
  };
};

export type GetPromotionsQueryVariables = Exact<{
  locationRef: Scalars["String"]["input"];
}>;

export type GetPromotionsQuery = {
  __typename?: "Query";
  promotions?: Array<{
    __typename?: "WebPromotion";
    id: string;
    displayOrder: number;
    title: string;
    badgeText: string;
    details?: string | null;
    collectionDescription?: string | null;
    imageUrl?: string | null;
    type: PromotionType;
    priceType: PromotionPriceType;
    rewardType?: PromotionRewardType | null;
    claimButtonText?: string | null;
    url?: string | null;
  }> | null;
};

export type ClaimPromotionMutationVariables = Exact<{
  promotionId: Scalars["String"]["input"];
  locationRef: Scalars["String"]["input"];
}>;

export type ClaimPromotionMutation = {
  __typename?: "Mutation";
  claimPromotion: {
    __typename?: "StandardMutationResult";
    error?: { __typename?: "MutationError"; message: string } | null;
  };
};

export type StartPromotionRedemptionMutationVariables = Exact<{
  promotionId: Scalars["String"]["input"];
  locationRef: Scalars["String"]["input"];
}>;

export type StartPromotionRedemptionMutation = {
  __typename?: "Mutation";
  startPromotionRedemption: {
    __typename?: "StartPromotionRedemptionResult";
    error?: { __typename?: "MutationError"; message: string } | null;
    session?: {
      __typename?: "OrderSession";
      id: string;
      paymentIntentSecret?: string | null;
      currency: string;
      creditAmount: number;
      discountAmount: number;
      paymentAmount: number;
      requirePhoneVerification?: boolean | null;
      summaryItems: Array<{
        __typename?: "SummaryItem";
        label: string;
        summaryItemType: SummaryItemType;
        amount: number;
        taxIncluded?: number | null;
      }>;
    } | null;
  };
};

export type CompletePromotionRedemptionMutationVariables = Exact<{
  orderId: Scalars["String"]["input"];
  locationRef: Scalars["String"]["input"];
}>;

export type CompletePromotionRedemptionMutation = {
  __typename?: "Mutation";
  completePromotionRedemption: {
    __typename?: "StandardMutationResult";
    error?: { __typename?: "MutationError"; message: string } | null;
  };
};

export type CancelPromotionRedemptionMutationVariables = Exact<{
  orderId: Scalars["String"]["input"];
}>;

export type CancelPromotionRedemptionMutation = {
  __typename?: "Mutation";
  cancelPromotionRedemption: {
    __typename?: "StandardMutationResult";
    error?: { __typename?: "MutationError"; message: string } | null;
  };
};

export type RewardCreditFieldsFragment = {
  __typename: "RewardCredit";
  id: string;
  amount: number;
  remaining: number;
  expiresAt?: string | null;
  title: string;
  locations?: Array<{
    __typename?: "Location";
    id: string;
    name: string;
  }> | null;
};

export type RewardDiscountFieldsFragment = {
  __typename: "RewardDiscount";
  id: string;
  name: string;
  rate: number;
  maxAmount?: number | null;
  maxRedemptionsPerCustomer?: number | null;
  remainingRedemptionsPerCustomer?: number | null;
  startAt?: string | null;
  expiresAt?: string | null;
  items?: Array<{ __typename?: "RewardItem"; id: string }> | null;
  locations?: Array<{ __typename?: "Location"; name: string }> | null;
  allocations?: Array<{
    __typename?: "RewardDiscountAllocation";
    id: string;
    expiresAt?: string | null;
  }> | null;
};

export type GetRewardsQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetRewardsQuery = {
  __typename?: "Query";
  rewards?: {
    __typename?: "RewardResult";
    items: Array<
      | {
          __typename: "RewardCredit";
          id: string;
          amount: number;
          remaining: number;
          expiresAt?: string | null;
          title: string;
          locations?: Array<{
            __typename?: "Location";
            id: string;
            name: string;
          }> | null;
        }
      | {
          __typename: "RewardDiscount";
          id: string;
          name: string;
          rate: number;
          maxAmount?: number | null;
          maxRedemptionsPerCustomer?: number | null;
          remainingRedemptionsPerCustomer?: number | null;
          startAt?: string | null;
          expiresAt?: string | null;
          items?: Array<{ __typename?: "RewardItem"; id: string }> | null;
          locations?: Array<{ __typename?: "Location"; name: string }> | null;
          allocations?: Array<{
            __typename?: "RewardDiscountAllocation";
            id: string;
            expiresAt?: string | null;
          }> | null;
        }
    >;
    pageInfo?: {
      __typename?: "PageInfo";
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
      endCursor: string;
    } | null;
  } | null;
};

export type GetRewardQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetRewardQuery = {
  __typename?: "Query";
  reward?:
    | {
        __typename: "RewardCredit";
        id: string;
        amount: number;
        remaining: number;
        expiresAt?: string | null;
        title: string;
        locations?: Array<{
          __typename?: "Location";
          id: string;
          name: string;
        }> | null;
      }
    | {
        __typename: "RewardDiscount";
        id: string;
        name: string;
        rate: number;
        maxAmount?: number | null;
        maxRedemptionsPerCustomer?: number | null;
        remainingRedemptionsPerCustomer?: number | null;
        startAt?: string | null;
        expiresAt?: string | null;
        items?: Array<{ __typename?: "RewardItem"; id: string }> | null;
        locations?: Array<{ __typename?: "Location"; name: string }> | null;
        allocations?: Array<{
          __typename?: "RewardDiscountAllocation";
          id: string;
          expiresAt?: string | null;
        }> | null;
      }
    | null;
};

export type GetStripeQueryVariables = Exact<{ [key: string]: never }>;

export type GetStripeQuery = {
  __typename?: "Query";
  merchant: { __typename?: "Merchant"; stripePublishableKey?: string | null };
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = {
  __typename?: "Query";
  me?: {
    __typename?: "Customer";
    firstName: string;
    lastName: string;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    dob?: string | null;
    isPaymentsVerified: boolean;
    hasAgreedToTerms: boolean;
  } | null;
  session?: { __typename?: "Session"; verified?: string | null } | null;
};

export type GetWebLinksQueryVariables = Exact<{
  locationRef: Scalars["String"]["input"];
}>;

export type GetWebLinksQuery = {
  __typename?: "Query";
  webLinks: Array<{ __typename?: "WebLink"; text: string; href: string }>;
};

export const BaseProductFieldsFragmentDoc = gql`
  fragment BaseProductFields on ProductV2 {
    id
    plu
    title
    description
    imageUrl
    available
    visibility {
      start
      end
      dayOfTheWeek
    }
    price {
      amount
      taxIncluded
    }
    tags
  }
`;
export const DeepProductFieldsFragmentDoc = gql`
  fragment DeepProductFields on ProductV2 {
    ...BaseProductFields
    options {
      id
      title
      minQuantity
      maxQuantity
      choices {
        minQuantity
        maxQuantity
        defaultQuantity
        product {
          ...BaseProductFields
          options {
            id
            title
            minQuantity
            maxQuantity
            choices {
              minQuantity
              maxQuantity
              defaultQuantity
              product {
                ...BaseProductFields
                options {
                  id
                  title
                  minQuantity
                  maxQuantity
                  choices {
                    minQuantity
                    maxQuantity
                    defaultQuantity
                    product {
                      ...BaseProductFields
                      options {
                        id
                        title
                        minQuantity
                        maxQuantity
                        choices {
                          minQuantity
                          maxQuantity
                          defaultQuantity
                          product {
                            ...BaseProductFields
                            options {
                              id
                              title
                              minQuantity
                              maxQuantity
                              choices {
                                minQuantity
                                maxQuantity
                                defaultQuantity
                                product {
                                  ...BaseProductFields
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${BaseProductFieldsFragmentDoc}
`;
export const RewardCreditFieldsFragmentDoc = gql`
  fragment RewardCreditFields on RewardCredit {
    id
    amount
    remaining
    expiresAt
    title
    locations {
      id
      name
    }
    __typename
  }
`;
export const RewardDiscountFieldsFragmentDoc = gql`
  fragment RewardDiscountFields on RewardDiscount {
    id
    name
    rate
    maxAmount
    items {
      id
    }
    locations {
      name
    }
    allocations {
      id
      expiresAt
    }
    maxRedemptionsPerCustomer
    remainingRedemptionsPerCustomer
    startAt
    expiresAt
    __typename
  }
`;
export const GetActivityDocument = gql`
  query GetActivity($after: String) {
    activity(first: 10, after: $after) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      items {
        __typename
        id
        title
        timestamp
        locationName
        ... on MessageActivity {
          body
        }
        ... on ItemExpiredActivity {
          item {
            id
            name
            expires
            claimed
            claimedLocation
            imageUrl
          }
        }
        ... on PromotionActivity {
          promotion {
            title
            details
            price
            priceType
          }
          promotionItem: item {
            name
            expires
            claimed
            claimedLocation
            imageUrl
          }
          promotionOrder: order {
            event {
              tone
              message
            }
            total
            tax
            itemTotal
            itemTax
            refId
            id
            billingType
            tipAmount
            creditAmount
            customerFeeAmount
            currency
            deliveryAddress {
              apartment
              streetAddress
              locality
              region
              country
              postcode
              coords {
                lat
                lng
              }
            }
            serviceRef
            items {
              amount
              tax
              name
              quantity
              options {
                name
                choices {
                  amount
                  name
                  tax
                }
              }
            }
            discounts {
              amount
              tax
              name
            }
          }
          promotionCredit: credit {
            id
            title
            amount
            remaining
            created
            expires
          }
          points
          pointsText
        }
        ... on CreditExpiredActivity {
          credit {
            id
            title
            amount
            remaining
            created
            expires
          }
        }
        ... on PointsActivity {
          points
          pointsText
        }
        ... on SpendActivity {
          pointsText
          points
          order {
            event {
              tone
              message
            }
            total
            tax
            itemTotal
            itemTax
            refId
            id
            billingType
            tipAmount
            creditAmount
            customerFeeAmount
            externalAmount
            currency
            paymentId
            paymentMethodType
            paymentMethodName
            paymentMethodIconUrl
            deliveryAddress {
              apartment
              streetAddress
              locality
              region
              country
              postcode
              coords {
                lat
                lng
              }
            }
            serviceRef
            items {
              amount
              tax
              name
              quantity
              options {
                name
                choices {
                  amount
                  name
                  tax
                }
              }
            }
            discounts {
              amount
              tax
              name
            }
            fulfillAt
            estimatedReadyAt
            deliveryAtMin
            deliveryAtMax
          }
          cart {
            locationId
            locationRef
            timestamp
            notes
            items {
              id
              note
              quantity
              options {
                id
                choices {
                  id
                  quantity
                  options {
                    id
                    choices {
                      id
                      quantity
                      options {
                        id
                        choices {
                          id
                          quantity
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const GetActivitySummaryDocument = gql`
  query GetActivitySummary {
    activity {
      summary {
        points
        credit
        itemCount
      }
    }
    rewards {
      items {
        ... on RewardDiscount {
          id
          __typename
        }
      }
    }
  }
`;
export const GetAddressesDocument = gql`
  query GetAddresses($query: String!, $locationRef: String) {
    addressAutocomplete(query: $query, locationRef: $locationRef) {
      name
      ref
    }
  }
`;
export const GetAddressDetailsDocument = gql`
  query GetAddressDetails($ref: String!) {
    addressDetails(ref: $ref) {
      details {
        name
        streetAddress
        locality
        postcode
        region
        country
        coords {
          lat
          lng
        }
      }
      error {
        message
      }
    }
  }
`;
export const RedeemCodeDocument = gql`
  mutation RedeemCode($code: String!) {
    redeemCode(code: $code) {
      error {
        message
      }
      messageDetails {
        title
        message
        ... on RewardMessageDetails {
          rewardType
        }
      }
    }
  }
`;
export const GetCreditDiscountDocument = gql`
  query GetCreditDiscount(
    $location: String!
    $orderTotal: Int!
    $orderItems: [OrderAheadItem!]
    $adjustments: [OrderAdjustment!]
    $fulfillmentType: FulfillmentType
    $selectedTimeSlot: String
    $currency: String
    $deliveryAddress: DeliveryAddress
  ) {
    balance(location: $location) {
      credit
    }
    discounts(
      location: $location
      total: $orderTotal
      items: $orderItems
      adjustments: $adjustments
      fulfillmentType: $fulfillmentType
      selectedTimeSlot: $selectedTimeSlot
      currency: $currency
      deliveryAddress: $deliveryAddress
    ) {
      id
      name
      discountAmount
      discountTax
      itemId
    }
  }
`;
export const GetFeaturesDocument = gql`
  query GetFeatures($keys: [String!]!, $deviceId: String) {
    features(keys: $keys, deviceId: $deviceId) {
      key
      enabled
    }
  }
`;
export const GetLanguageStringsDocument = gql`
  query GetLanguageStrings {
    strings {
      webOrderPickupName
      webOrderDeliveryName
      webOrderServiceName
      webChooseLocationTitle
      serviceChargeTitle
      serviceChargeBody
      serviceChargeApply
      serviceChargeRemove
      webServiceRefLabel
      webPlaceRefLabel
      webExternalPaymentPickUpButton
      webExternalPaymentPickUpMessage
      webExternalPaymentDeliveryButton
      webExternalPaymentDeliveryMessage
      webExternalPaymentServiceButton
      webExternalPaymentServiceMessage
    }
  }
`;
export const GetLocationDocument = gql`
  query GetLocation($locationRef: String!) {
    merchant {
      name
      location(locationRef: $locationRef) {
        id
        uid
        slug
        name
        phoneNumber
        openingHours
        website
        address {
          street
          locality
          region
          postalCode
          country
        }
        coords {
          latitude: lat
          longitude: lng
        }
        social {
          facebook
          twitter
          instagram
        }
        orderAheadEnabled
        orderAtTableEnabled
        orderDeliveryEnabled
        timezone
      }
    }
  }
`;
export const GetLocationsDocument = gql`
  query GetLocations(
    $nativeOrderingEnabled: Boolean
    $currentCoords: CoordsInput
  ) {
    merchant {
      name
      locations(
        nativeOrderingEnabled: $nativeOrderingEnabled
        myLocation: $currentCoords
      ) {
        id
        uid
        slug
        name
        phoneNumber
        openingHours
        website
        address {
          street
          locality
          region
          postalCode
          country
        }
        coords {
          latitude: lat
          longitude: lng
        }
        social {
          facebook
          twitter
          instagram
        }
        orderAheadEnabled
        orderAtTableEnabled
        orderDeliveryEnabled
        timezone
      }
    }
  }
`;
export const GetLoginConfigDocument = gql`
  query GetLoginConfig {
    merchant {
      googleClientId
      appleWebClientId
      settings {
        loginProviders
      }
    }
  }
`;
export const GetMerchantDocument = gql`
  query GetMerchant {
    merchant {
      uid
      androidStoreUrl
      iosStoreUrl
      currency
      settings {
        termsAndConditionsURL
      }
    }
  }
`;
export const GetMerchantRequiresPhoneDocument = gql`
  query GetMerchantRequiresPhone {
    merchant {
      settings {
        requirePhoneWeb
      }
    }
  }
`;
export const CreateOrderDocument = gql`
  mutation CreateOrder(
    $id: String!
    $locationRef: String!
    $total: Int!
    $items: [OrderAheadItem!]!
    $notes: String
    $deliveryAddress: DeliveryAddress
    $serviceRef: String
    $tip: Int
    $timeSlot: String
  ) {
    createOrder(
      id: $id
      location: $locationRef
      total: $total
      items: $items
      deliveryAddress: $deliveryAddress
      notes: $notes
      serviceRef: $serviceRef
      tip: $tip
      timeSlot: $timeSlot
    ) {
      session {
        id
        currency
        paymentIntentSecret
        creditAmount
        discountAmount
        paymentAmount
        summaryItems {
          label
          summaryItemType
          amount
          taxIncluded
        }
        requirePhoneVerification
      }
      error {
        message
      }
    }
  }
`;
export const UpdateOrderTipDocument = gql`
  mutation UpdateOrderTip($orderId: String!, $tip: Int!) {
    updateOrderTip(id: $orderId, tip: $tip) {
      error {
        message
      }
    }
  }
`;
export const CompleteOrderDocument = gql`
  mutation CompleteOrder($orderId: String!, $externalPayment: Boolean) {
    completeOrder(id: $orderId, externalPayment: $externalPayment) {
      error {
        message
      }
    }
  }
`;
export const CancelOrderDocument = gql`
  mutation CancelOrder($orderId: String!) {
    cancelOrder(id: $orderId) {
      error {
        message
      }
    }
  }
`;
export const GetProductDocument = gql`
  query GetProduct($location: String!, $productId: String!) {
    ordering(locationRef: $location) {
      product(productId: $productId) {
        ...DeepProductFields
      }
    }
  }
  ${DeepProductFieldsFragmentDoc}
`;
export const GetMenusDocument = gql`
  query GetMenus(
    $location: String!
    $dispatchOption: FulfillmentType
    $productIds: [String!]
  ) {
    ordering(locationRef: $location) {
      menus(fulfillmentType: $dispatchOption) {
        id
        title
        fulfillmentType
        categories {
          id
          title
          products(productIds: $productIds) {
            ...DeepProductFields
          }
        }
        serviceAvailability {
          dayOfTheWeek
          start
          end
        }
      }
    }
  }
  ${DeepProductFieldsFragmentDoc}
`;
export const GetBaseMenusDocument = gql`
  query GetBaseMenus($location: String!, $dispatchOption: FulfillmentType) {
    ordering(locationRef: $location) {
      menus(fulfillmentType: $dispatchOption) {
        id
        title
        fulfillmentType
        categories {
          id
          title
          products {
            ...BaseProductFields
          }
        }
        serviceAvailability {
          dayOfTheWeek
          start
          end
        }
      }
    }
  }
  ${BaseProductFieldsFragmentDoc}
`;
export const GetOrderingDocument = gql`
  query GetOrdering($location: String!, $to: CoordsInput) {
    ordering(locationRef: $location) {
      deliveryConfig(to: $to) {
        active
        minimumAmount
        feeAmount
        feePrice {
          amount
          taxIncluded
        }
        minutesMin
        minutesMax
        allowItemNotes
        allowOrderNotes
        orderNotesMaxLength
        itemNotesMaxLength
        tipsEnabled
        tipRatios
        tipDefaultIndex
        externalPaymentEnabled
        timeSlots {
          startTime
          endTime
          available
          ref
        }
      }
      pickupConfig {
        active
        waitTime
        allowItemNotes
        allowOrderNotes
        orderNotesMaxLength
        itemNotesMaxLength
        tipsEnabled
        tipRatios
        tipDefaultIndex
        timeSlots {
          startTime
          endTime
          available
          ref
        }
        externalPaymentEnabled
      }
      serviceConfig {
        waitTime
        active
        validRefs {
          ref
        }
        serviceChargeLabel
        serviceChargeRate
        allowItemNotes
        allowOrderNotes
        orderNotesMaxLength
        itemNotesMaxLength
        tipsEnabled
        tipRatios
        tipDefaultIndex
        externalPaymentEnabled
      }
    }
  }
`;
export const CheckDeliveryAddressDocument = gql`
  query CheckDeliveryAddress($location: String!, $address: DeliveryAddress!) {
    ordering(locationRef: $location) {
      deliveryAddressStatus(address: $address) {
        valid
        messages
      }
    }
  }
`;
export const GetRecentCartsDocument = gql`
  query GetRecentCarts($location: String!, $limit: Int!) {
    ordering(locationRef: $location) {
      recentCarts(limit: $limit) {
        locationRef
        locationId
        fulfillmentType
        notes
        timestamp
        items {
          id
          quantity
          note
          options {
            id
            choices {
              id
              quantity
              options {
                id
                choices {
                  id
                  quantity
                  options {
                    id
                    choices {
                      id
                      quantity
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const GetPayRequirementsDocument = gql`
  query GetPayRequirements {
    merchant {
      settings {
        requirePhoneWeb
      }
    }
    me {
      firstName
      lastName
      emailAddress
      phoneNumber
      dob
      hasVerifiedPayments: isPaymentsVerified
      hasAgreedToTerms
    }
  }
`;
export const GetPaymentMethodsDocument = gql`
  query GetPaymentMethods {
    me {
      paymentMethods {
        id
        typeText
        idText
        displayText
        iconUrl
      }
    }
  }
`;
export const RemovePaymentMethodDocument = gql`
  mutation RemovePaymentMethod($paymentMethod: String!) {
    removePaymentMethodV2(paymentMethod: $paymentMethod) {
      error {
        message
      }
    }
  }
`;
export const GetPaymentDocument = gql`
  query GetPayment($paymentId: String!) {
    payment(paymentId: $paymentId) {
      state
      session: orderSession {
        id
        paymentIntentSecret
        currency
        creditAmount
        discountAmount
        summaryItems {
          label
          summaryItemType
          amount
          taxIncluded
        }
        paymentAmount
        requirePhoneVerification
        tipAmount
      }
    }
  }
`;
export const GetTransactionDocument = gql`
  query GetTransaction($paymentId: String!) {
    order(orderId: $paymentId) {
      points
      location {
        id
        slug
        name
      }
      created
      fulfillAt
      estimatedReadyAt
      deliveryAtMin
      deliveryAtMax
      event {
        tone
        message
        timestamp
      }
      total
      tax
      itemTotal
      itemTax
      billingType
      tipAmount
      creditAmount
      customerFeeAmount
      externalAmount
      currency
      paymentMethodType
      paymentMethodName
      paymentMethodIconUrl
      serviceRef
      orderAcceptedAt
      items {
        amount
        tax
        name
        quantity
        options {
          name
          choices {
            amount
            name
            tax
          }
        }
      }
      discounts {
        amount
        tax
        name
      }
    }
  }
`;
export const RequestPhoneVerificationDocument = gql`
  mutation RequestPhoneVerification($phoneNumber: String!) {
    requestPhoneNumberVerification(phoneNumber: $phoneNumber) {
      error {
        message
      }
    }
  }
`;
export const VerifyPhoneDocument = gql`
  mutation VerifyPhone($code: String!) {
    verifyPhoneNumber(verificationCode: $code) {
      error {
        message
        code
      }
    }
  }
`;
export const GetUserProfileFieldsDocument = gql`
  query GetUserProfileFields($scope: ProfileScope!) {
    profileFields(scope: $scope) {
      label
      formattedLabel
      field
      value
      type
      required
    }
  }
`;
export const GetPromotionsHeaderDocument = gql`
  query GetPromotionsHeader($locationRef: String!) {
    strings {
      noPointsText
    }
    balance(location: $locationRef) {
      pointsText
      creditText
      credit
    }
  }
`;
export const GetPromotionsDocument = gql`
  query GetPromotions($locationRef: String!) {
    promotions(locationId: $locationRef) {
      id
      displayOrder
      title
      badgeText
      details
      collectionDescription
      imageUrl
      type
      priceType
      rewardType
      claimButtonText
      url
    }
  }
`;
export const ClaimPromotionDocument = gql`
  mutation ClaimPromotion($promotionId: String!, $locationRef: String!) {
    claimPromotion(promotionId: $promotionId, locationId: $locationRef) {
      error {
        message
      }
    }
  }
`;
export const StartPromotionRedemptionDocument = gql`
  mutation StartPromotionRedemption(
    $promotionId: String!
    $locationRef: String!
  ) {
    startPromotionRedemption(
      promotionId: $promotionId
      locationId: $locationRef
    ) {
      error {
        message
      }
      session {
        id
        paymentIntentSecret
        currency
        creditAmount
        discountAmount
        paymentAmount
        summaryItems {
          label
          summaryItemType
          amount
          taxIncluded
        }
        requirePhoneVerification
      }
    }
  }
`;
export const CompletePromotionRedemptionDocument = gql`
  mutation CompletePromotionRedemption(
    $orderId: String!
    $locationRef: String!
  ) {
    completePromotionRedemption(orderId: $orderId, locationId: $locationRef) {
      error {
        message
      }
    }
  }
`;
export const CancelPromotionRedemptionDocument = gql`
  mutation CancelPromotionRedemption($orderId: String!) {
    cancelPromotionRedemption(orderId: $orderId) {
      error {
        message
      }
    }
  }
`;
export const GetRewardsDocument = gql`
  query GetRewards($after: String) {
    rewards(limit: 100, after: $after) {
      items {
        ...RewardCreditFields
        ...RewardDiscountFields
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${RewardCreditFieldsFragmentDoc}
  ${RewardDiscountFieldsFragmentDoc}
`;
export const GetRewardDocument = gql`
  query GetReward($id: String!) {
    reward(id: $id) {
      ...RewardCreditFields
      ...RewardDiscountFields
    }
  }
  ${RewardCreditFieldsFragmentDoc}
  ${RewardDiscountFieldsFragmentDoc}
`;
export const GetStripeDocument = gql`
  query GetStripe {
    merchant {
      stripePublishableKey
    }
  }
`;
export const GetCurrentUserDocument = gql`
  query GetCurrentUser {
    me {
      firstName
      lastName
      emailAddress
      phoneNumber
      dob
      isPaymentsVerified
      hasAgreedToTerms
    }
    session {
      verified
    }
  }
`;
export const GetWebLinksDocument = gql`
  query GetWebLinks($locationRef: String!) {
    webLinks(locationRef: $locationRef) {
      text
      href
    }
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType,
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper,
) {
  return {
    GetActivity(
      variables?: GetActivityQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetActivityQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetActivityQuery>(GetActivityDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetActivity",
        "query",
      );
    },
    GetActivitySummary(
      variables?: GetActivitySummaryQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetActivitySummaryQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetActivitySummaryQuery>(
            GetActivitySummaryDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetActivitySummary",
        "query",
      );
    },
    GetAddresses(
      variables: GetAddressesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetAddressesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetAddressesQuery>(GetAddressesDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetAddresses",
        "query",
      );
    },
    GetAddressDetails(
      variables: GetAddressDetailsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetAddressDetailsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetAddressDetailsQuery>(
            GetAddressDetailsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetAddressDetails",
        "query",
      );
    },
    RedeemCode(
      variables: RedeemCodeMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<RedeemCodeMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RedeemCodeMutation>(RedeemCodeDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "RedeemCode",
        "mutation",
      );
    },
    GetCreditDiscount(
      variables: GetCreditDiscountQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetCreditDiscountQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCreditDiscountQuery>(
            GetCreditDiscountDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetCreditDiscount",
        "query",
      );
    },
    GetFeatures(
      variables: GetFeaturesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetFeaturesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetFeaturesQuery>(GetFeaturesDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetFeatures",
        "query",
      );
    },
    GetLanguageStrings(
      variables?: GetLanguageStringsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetLanguageStringsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetLanguageStringsQuery>(
            GetLanguageStringsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetLanguageStrings",
        "query",
      );
    },
    GetLocation(
      variables: GetLocationQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetLocationQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetLocationQuery>(GetLocationDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetLocation",
        "query",
      );
    },
    GetLocations(
      variables?: GetLocationsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetLocationsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetLocationsQuery>(GetLocationsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetLocations",
        "query",
      );
    },
    GetLoginConfig(
      variables?: GetLoginConfigQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetLoginConfigQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetLoginConfigQuery>(
            GetLoginConfigDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetLoginConfig",
        "query",
      );
    },
    GetMerchant(
      variables?: GetMerchantQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetMerchantQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetMerchantQuery>(GetMerchantDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetMerchant",
        "query",
      );
    },
    GetMerchantRequiresPhone(
      variables?: GetMerchantRequiresPhoneQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetMerchantRequiresPhoneQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetMerchantRequiresPhoneQuery>(
            GetMerchantRequiresPhoneDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetMerchantRequiresPhone",
        "query",
      );
    },
    CreateOrder(
      variables: CreateOrderMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<CreateOrderMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateOrderMutation>(CreateOrderDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "CreateOrder",
        "mutation",
      );
    },
    UpdateOrderTip(
      variables: UpdateOrderTipMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<UpdateOrderTipMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateOrderTipMutation>(
            UpdateOrderTipDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "UpdateOrderTip",
        "mutation",
      );
    },
    CompleteOrder(
      variables: CompleteOrderMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<CompleteOrderMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CompleteOrderMutation>(
            CompleteOrderDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "CompleteOrder",
        "mutation",
      );
    },
    CancelOrder(
      variables: CancelOrderMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<CancelOrderMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CancelOrderMutation>(CancelOrderDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "CancelOrder",
        "mutation",
      );
    },
    GetProduct(
      variables: GetProductQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetProductQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetProductQuery>(GetProductDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetProduct",
        "query",
      );
    },
    GetMenus(
      variables: GetMenusQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetMenusQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetMenusQuery>(GetMenusDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetMenus",
        "query",
      );
    },
    GetBaseMenus(
      variables: GetBaseMenusQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetBaseMenusQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetBaseMenusQuery>(GetBaseMenusDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetBaseMenus",
        "query",
      );
    },
    GetOrdering(
      variables: GetOrderingQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetOrderingQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetOrderingQuery>(GetOrderingDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetOrdering",
        "query",
      );
    },
    CheckDeliveryAddress(
      variables: CheckDeliveryAddressQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<CheckDeliveryAddressQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CheckDeliveryAddressQuery>(
            CheckDeliveryAddressDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "CheckDeliveryAddress",
        "query",
      );
    },
    GetRecentCarts(
      variables: GetRecentCartsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetRecentCartsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetRecentCartsQuery>(
            GetRecentCartsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetRecentCarts",
        "query",
      );
    },
    GetPayRequirements(
      variables?: GetPayRequirementsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetPayRequirementsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPayRequirementsQuery>(
            GetPayRequirementsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetPayRequirements",
        "query",
      );
    },
    GetPaymentMethods(
      variables?: GetPaymentMethodsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetPaymentMethodsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPaymentMethodsQuery>(
            GetPaymentMethodsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetPaymentMethods",
        "query",
      );
    },
    RemovePaymentMethod(
      variables: RemovePaymentMethodMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<RemovePaymentMethodMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RemovePaymentMethodMutation>(
            RemovePaymentMethodDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "RemovePaymentMethod",
        "mutation",
      );
    },
    GetPayment(
      variables: GetPaymentQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetPaymentQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPaymentQuery>(GetPaymentDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetPayment",
        "query",
      );
    },
    GetTransaction(
      variables: GetTransactionQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetTransactionQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetTransactionQuery>(
            GetTransactionDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetTransaction",
        "query",
      );
    },
    RequestPhoneVerification(
      variables: RequestPhoneVerificationMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<RequestPhoneVerificationMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<RequestPhoneVerificationMutation>(
            RequestPhoneVerificationDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "RequestPhoneVerification",
        "mutation",
      );
    },
    VerifyPhone(
      variables: VerifyPhoneMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<VerifyPhoneMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<VerifyPhoneMutation>(VerifyPhoneDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "VerifyPhone",
        "mutation",
      );
    },
    GetUserProfileFields(
      variables: GetUserProfileFieldsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetUserProfileFieldsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetUserProfileFieldsQuery>(
            GetUserProfileFieldsDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetUserProfileFields",
        "query",
      );
    },
    GetPromotionsHeader(
      variables: GetPromotionsHeaderQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetPromotionsHeaderQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPromotionsHeaderQuery>(
            GetPromotionsHeaderDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetPromotionsHeader",
        "query",
      );
    },
    GetPromotions(
      variables: GetPromotionsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetPromotionsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetPromotionsQuery>(GetPromotionsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetPromotions",
        "query",
      );
    },
    ClaimPromotion(
      variables: ClaimPromotionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<ClaimPromotionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ClaimPromotionMutation>(
            ClaimPromotionDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "ClaimPromotion",
        "mutation",
      );
    },
    StartPromotionRedemption(
      variables: StartPromotionRedemptionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<StartPromotionRedemptionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<StartPromotionRedemptionMutation>(
            StartPromotionRedemptionDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "StartPromotionRedemption",
        "mutation",
      );
    },
    CompletePromotionRedemption(
      variables: CompletePromotionRedemptionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<CompletePromotionRedemptionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CompletePromotionRedemptionMutation>(
            CompletePromotionRedemptionDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "CompletePromotionRedemption",
        "mutation",
      );
    },
    CancelPromotionRedemption(
      variables: CancelPromotionRedemptionMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<CancelPromotionRedemptionMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CancelPromotionRedemptionMutation>(
            CancelPromotionRedemptionDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "CancelPromotionRedemption",
        "mutation",
      );
    },
    GetRewards(
      variables?: GetRewardsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetRewardsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetRewardsQuery>(GetRewardsDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetRewards",
        "query",
      );
    },
    GetReward(
      variables: GetRewardQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetRewardQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetRewardQuery>(GetRewardDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetReward",
        "query",
      );
    },
    GetStripe(
      variables?: GetStripeQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetStripeQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetStripeQuery>(GetStripeDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetStripe",
        "query",
      );
    },
    GetCurrentUser(
      variables?: GetCurrentUserQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetCurrentUserQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetCurrentUserQuery>(
            GetCurrentUserDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        "GetCurrentUser",
        "query",
      );
    },
    GetWebLinks(
      variables: GetWebLinksQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
    ): Promise<GetWebLinksQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetWebLinksQuery>(GetWebLinksDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        "GetWebLinks",
        "query",
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
